(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[4327],{

/***/ 79361:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({
    value: true
});
exports.Z = _defineProperty;
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}


/***/ }),

/***/ 31365:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

module.exports = __webpack_require__(55532)


/***/ }),

/***/ 89020:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "u": function() { return /* binding */ captureUnderscoreErrorException; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(77668);
/* harmony import */ var _utils_responseEnd_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(84063);




function captureUnderscoreErrorException(contextOrProps) {
    return _captureUnderscoreErrorException.apply(this, arguments);
}
function _captureUnderscoreErrorException() {
    _captureUnderscoreErrorException = /**
 * Capture the exception passed by nextjs to the `_error` page, adding context data as appropriate.
 *
 * @param contextOrProps The data passed to either `getInitialProps` or `render` by nextjs
 */ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(contextOrProps) {
        var req, res, err, statusCode;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    req = contextOrProps.req, res = contextOrProps.res, err = contextOrProps.err;
                    statusCode = res && res.statusCode || contextOrProps.statusCode;
                    if (statusCode && statusCode < 500) {
                        return [
                            2,
                            Promise.resolve()
                        ];
                    }
                    // In previous versions of the suggested `_error.js` page in which this function is meant to be used, there was a
                    // workaround for https://github.com/vercel/next.js/issues/8592 which involved an extra call to this function, in the
                    // custom error component's `render` method, just in case it hadn't been called by `getInitialProps`. Now that that
                    // issue has been fixed, the second call is unnecessary, but since it lives in user code rather than our code, users
                    // have to be the ones to get rid of it, and guaraneteedly, not all of them will. So, rather than capture the error
                    // twice, we just bail if we sense we're in that now-extraneous second call. (We can tell which function we're in
                    // because Nextjs passes `pathname` to `getInitialProps` but not to `render`.)
                    if (!contextOrProps.pathname) {
                        return [
                            2,
                            Promise.resolve()
                        ];
                    }
                    (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .withScope */ .$e)(function(scope) {
                        if (req) {
                            scope.setSDKProcessingMetadata({
                                request: req
                            });
                        }
                        // If third-party libraries (or users themselves) throw something falsy, we want to capture it as a message (which
                        // is what passing a string to `captureException` will wind up doing)
                        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .captureException */ .Tb)(err || "_error.js called with falsy error (".concat(err, ")"), {
                            mechanism: {
                                type: "instrument",
                                handled: false,
                                data: {
                                    function: "_error.getInitialProps"
                                }
                            }
                        });
                    });
                    // In case this is being run as part of a serverless function (as is the case with the server half of nextjs apps
                    // deployed to vercel), make sure the error gets sent to Sentry before the lambda exits.
                    return [
                        4,
                        (0,_utils_responseEnd_js__WEBPACK_IMPORTED_MODULE_3__/* .flushQueue */ .DO)()
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    });
    return _captureUnderscoreErrorException.apply(this, arguments);
}
 //# sourceMappingURL=_error.js.map


/***/ }),

/***/ 46748:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ DEBUG_BUILD; }
/* harmony export */ });
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD =  false || false;
 //# sourceMappingURL=debug-build.js.map


/***/ }),

/***/ 84063:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DO": function() { return /* binding */ flushQueue; },
/* harmony export */   "RR": function() { return /* binding */ autoEndSpanOnResponseEnd; }
/* harmony export */ });
/* unused harmony export finishSpan */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(36305);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(97582);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(86912);
/* harmony import */ var _sentry_core__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(77668);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(27389);
/* harmony import */ var _sentry_utils__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(92957);
/* harmony import */ var _debug_build_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46748);






/**
 * Wrap `res.end()` so that it ends the span and flushes events before letting the request finish.
 *
 * Note: This wraps a sync method with an async method. While in general that's not a great idea in terms of keeping
 * things in the right order, in this case it's safe, because the native `.end()` actually *is* (effectively) async, and
 * its run actually *is* (literally) awaited, just manually so (which reflects the fact that the core of the
 * request/response code in Node by far predates the introduction of `async`/`await`). When `.end()` is done, it emits
 * the `prefinish` event, and only once that fires does request processing continue. See
 * https://github.com/nodejs/node/commit/7c9b607048f13741173d397795bac37707405ba7.
 *
 * Also note: `res.end()` isn't called until *after* all response data and headers have been sent, so blocking inside of
 * `end` doesn't delay data getting to the end user. See
 * https://nodejs.org/api/http.html#responseenddata-encoding-callback.
 *
 * @param span The span tracking the request
 * @param res: The request's corresponding response
 */ function autoEndSpanOnResponseEnd(span, res) {
    var wrapEndMethod = function(origEnd) {
        return function sentryWrappedEnd() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            var _origEnd;
            finishSpan(span, this);
            return (_origEnd = origEnd).call.apply(_origEnd, [
                this
            ].concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(args)));
        };
    };
    // Prevent double-wrapping
    // res.end may be undefined during build when using `next export` to statically export a Next.js app
    if (res.end && !res.end.__sentry_original__) {
        (0,_sentry_utils__WEBPACK_IMPORTED_MODULE_1__/* .fill */ .hl)(res, "end", wrapEndMethod);
    }
}
/** Finish the given response's span and set HTTP status data */ function finishSpan(span, res) {
    if (span) {
        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_2__/* .setHttpStatus */ .Q0)(span, res.statusCode);
        span.end();
    }
}
function flushQueue() {
    return _flushQueue.apply(this, arguments);
}
function _flushQueue() {
    _flushQueue = /** Flush the event queue to ensure that events get sent to Sentry before the response is finished and the lambda ends */ (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(function() {
        var e;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_4__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_5__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.log */ .kg.log("Flushing events...");
                    return [
                        4,
                        (0,_sentry_core__WEBPACK_IMPORTED_MODULE_7__/* .flush */ .yl)(2000)
                    ];
                case 1:
                    _state.sent();
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_5__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.log */ .kg.log("Done flushing events");
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    _debug_build_js__WEBPACK_IMPORTED_MODULE_5__/* .DEBUG_BUILD */ .X && _sentry_utils__WEBPACK_IMPORTED_MODULE_6__/* .logger.log */ .kg.log("Error while flushing events:\n", e);
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return _flushQueue.apply(this, arguments);
}
 //# sourceMappingURL=responseEnd.js.map


/***/ }),

/***/ 34327:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Breadcrumbs": function() { return /* reexport */ esm.Breadcrumbs; },
  "BrowserClient": function() { return /* reexport */ esm.BrowserClient; },
  "BrowserProfilingIntegration": function() { return /* reexport */ esm.BrowserProfilingIntegration; },
  "BrowserTracing": function() { return /* reexport */ BrowserTracing; },
  "Dedupe": function() { return /* reexport */ esm.Dedupe; },
  "ErrorBoundary": function() { return /* reexport */ ErrorBoundary; },
  "Feedback": function() { return /* reexport */ esm.Feedback; },
  "FunctionToString": function() { return /* reexport */ esm.FunctionToString; },
  "GlobalHandlers": function() { return /* reexport */ esm.GlobalHandlers; },
  "HttpContext": function() { return /* reexport */ esm.HttpContext; },
  "Hub": function() { return /* reexport */ esm.Hub; },
  "InboundFilters": function() { return /* reexport */ esm.InboundFilters; },
  "Integrations": function() { return /* reexport */ Integrations; },
  "LinkedErrors": function() { return /* reexport */ esm.LinkedErrors; },
  "ModuleMetadata": function() { return /* reexport */ esm.ModuleMetadata; },
  "Profiler": function() { return /* reexport */ Profiler; },
  "Replay": function() { return /* reexport */ esm.Replay; },
  "ReplayCanvas": function() { return /* reexport */ esm.ReplayCanvas; },
  "SDK_VERSION": function() { return /* reexport */ esm.SDK_VERSION; },
  "SEMANTIC_ATTRIBUTE_SENTRY_OP": function() { return /* reexport */ esm.SEMANTIC_ATTRIBUTE_SENTRY_OP; },
  "SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN": function() { return /* reexport */ esm.SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN; },
  "SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE": function() { return /* reexport */ esm.SEMANTIC_ATTRIBUTE_SENTRY_SAMPLE_RATE; },
  "SEMANTIC_ATTRIBUTE_SENTRY_SOURCE": function() { return /* reexport */ esm.SEMANTIC_ATTRIBUTE_SENTRY_SOURCE; },
  "Scope": function() { return /* reexport */ esm.Scope; },
  "TryCatch": function() { return /* reexport */ esm.TryCatch; },
  "WINDOW": function() { return /* reexport */ esm.WINDOW; },
  "addBreadcrumb": function() { return /* reexport */ esm.addBreadcrumb; },
  "addEventProcessor": function() { return /* reexport */ esm.addEventProcessor; },
  "addGlobalEventProcessor": function() { return /* reexport */ esm.addGlobalEventProcessor; },
  "addIntegration": function() { return /* reexport */ esm.addIntegration; },
  "addTracingExtensions": function() { return /* reexport */ esm.addTracingExtensions; },
  "breadcrumbsIntegration": function() { return /* reexport */ esm.breadcrumbsIntegration; },
  "browserApiErrorsIntegration": function() { return /* reexport */ esm.browserApiErrorsIntegration; },
  "browserProfilingIntegration": function() { return /* reexport */ esm.browserProfilingIntegration; },
  "browserTracingIntegration": function() { return /* reexport */ browserTracingIntegration_browserTracingIntegration; },
  "captureConsoleIntegration": function() { return /* reexport */ esm.captureConsoleIntegration; },
  "captureEvent": function() { return /* reexport */ esm.captureEvent; },
  "captureException": function() { return /* reexport */ esm.captureException; },
  "captureMessage": function() { return /* reexport */ esm.captureMessage; },
  "captureSession": function() { return /* reexport */ esm.captureSession; },
  "captureUnderscoreErrorException": function() { return /* reexport */ _error/* captureUnderscoreErrorException */.u; },
  "captureUserFeedback": function() { return /* reexport */ esm.captureUserFeedback; },
  "chromeStackLineParser": function() { return /* reexport */ esm.chromeStackLineParser; },
  "close": function() { return /* reexport */ esm.close; },
  "configureScope": function() { return /* reexport */ esm.configureScope; },
  "contextLinesIntegration": function() { return /* reexport */ esm.contextLinesIntegration; },
  "continueTrace": function() { return /* reexport */ esm.continueTrace; },
  "createReduxEnhancer": function() { return /* reexport */ createReduxEnhancer; },
  "createTransport": function() { return /* reexport */ esm.createTransport; },
  "createUserFeedbackEnvelope": function() { return /* reexport */ esm.createUserFeedbackEnvelope; },
  "debugIntegration": function() { return /* reexport */ esm.debugIntegration; },
  "dedupeIntegration": function() { return /* reexport */ esm.dedupeIntegration; },
  "defaultIntegrations": function() { return /* reexport */ esm.defaultIntegrations; },
  "defaultRequestInstrumentationOptions": function() { return /* reexport */ esm.defaultRequestInstrumentationOptions; },
  "defaultStackLineParsers": function() { return /* reexport */ esm.defaultStackLineParsers; },
  "defaultStackParser": function() { return /* reexport */ esm.defaultStackParser; },
  "endSession": function() { return /* reexport */ esm.endSession; },
  "eventFromException": function() { return /* reexport */ esm.eventFromException; },
  "eventFromMessage": function() { return /* reexport */ esm.eventFromMessage; },
  "exceptionFromError": function() { return /* reexport */ esm.exceptionFromError; },
  "extraErrorDataIntegration": function() { return /* reexport */ esm.extraErrorDataIntegration; },
  "extractTraceparentData": function() { return /* reexport */ esm.extractTraceparentData; },
  "feedbackIntegration": function() { return /* reexport */ esm.feedbackIntegration; },
  "flush": function() { return /* reexport */ esm.flush; },
  "forceLoad": function() { return /* reexport */ esm.forceLoad; },
  "functionToStringIntegration": function() { return /* reexport */ esm.functionToStringIntegration; },
  "geckoStackLineParser": function() { return /* reexport */ esm.geckoStackLineParser; },
  "getActiveSpan": function() { return /* reexport */ esm.getActiveSpan; },
  "getActiveTransaction": function() { return /* reexport */ esm.getActiveTransaction; },
  "getClient": function() { return /* reexport */ esm.getClient; },
  "getCurrentHub": function() { return /* reexport */ esm.getCurrentHub; },
  "getCurrentScope": function() { return /* reexport */ esm.getCurrentScope; },
  "getDefaultIntegrations": function() { return /* reexport */ esm.getDefaultIntegrations; },
  "getHubFromCarrier": function() { return /* reexport */ esm.getHubFromCarrier; },
  "getReplay": function() { return /* reexport */ esm.getReplay; },
  "getSpanStatusFromHttpCode": function() { return /* reexport */ esm.getSpanStatusFromHttpCode; },
  "globalHandlersIntegration": function() { return /* reexport */ esm.globalHandlersIntegration; },
  "httpClientIntegration": function() { return /* reexport */ esm.httpClientIntegration; },
  "httpContextIntegration": function() { return /* reexport */ esm.httpContextIntegration; },
  "inboundFiltersIntegration": function() { return /* reexport */ esm.inboundFiltersIntegration; },
  "init": function() { return /* reexport */ client_init; },
  "instrumentOutgoingRequests": function() { return /* reexport */ esm.instrumentOutgoingRequests; },
  "isInitialized": function() { return /* reexport */ esm.isInitialized; },
  "lastEventId": function() { return /* reexport */ esm.lastEventId; },
  "linkedErrorsIntegration": function() { return /* reexport */ esm.linkedErrorsIntegration; },
  "makeBrowserOfflineTransport": function() { return /* reexport */ esm.makeBrowserOfflineTransport; },
  "makeFetchTransport": function() { return /* reexport */ esm.makeFetchTransport; },
  "makeMain": function() { return /* reexport */ esm.makeMain; },
  "makeMultiplexedTransport": function() { return /* reexport */ esm.makeMultiplexedTransport; },
  "makeXHRTransport": function() { return /* reexport */ esm.makeXHRTransport; },
  "metrics": function() { return /* reexport */ esm.metrics; },
  "moduleMetadataIntegration": function() { return /* reexport */ esm.moduleMetadataIntegration; },
  "nextRouterInstrumentation": function() { return /* reexport */ nextRouterInstrumentation; },
  "onLoad": function() { return /* reexport */ esm.onLoad; },
  "onProfilingStartRouteTransaction": function() { return /* reexport */ esm.onProfilingStartRouteTransaction; },
  "opera10StackLineParser": function() { return /* reexport */ esm.opera10StackLineParser; },
  "opera11StackLineParser": function() { return /* reexport */ esm.opera11StackLineParser; },
  "parameterize": function() { return /* reexport */ esm.parameterize; },
  "reactRouterV3BrowserTracingIntegration": function() { return /* reexport */ reactRouterV3BrowserTracingIntegration; },
  "reactRouterV3Instrumentation": function() { return /* reexport */ reactRouterV3Instrumentation; },
  "reactRouterV4BrowserTracingIntegration": function() { return /* reexport */ reactRouterV4BrowserTracingIntegration; },
  "reactRouterV4Instrumentation": function() { return /* reexport */ reactRouterV4Instrumentation; },
  "reactRouterV5BrowserTracingIntegration": function() { return /* reexport */ reactRouterV5BrowserTracingIntegration; },
  "reactRouterV5Instrumentation": function() { return /* reexport */ reactRouterV5Instrumentation; },
  "reactRouterV6BrowserTracingIntegration": function() { return /* reexport */ reactRouterV6BrowserTracingIntegration; },
  "reactRouterV6Instrumentation": function() { return /* reexport */ reactRouterV6Instrumentation; },
  "replayCanvasIntegration": function() { return /* reexport */ esm.replayCanvasIntegration; },
  "replayIntegration": function() { return /* reexport */ esm.replayIntegration; },
  "reportingObserverIntegration": function() { return /* reexport */ esm.reportingObserverIntegration; },
  "rewriteFramesIntegration": function() { return /* reexport */ rewriteFramesIntegration; },
  "sendFeedback": function() { return /* reexport */ esm.sendFeedback; },
  "sessionTimingIntegration": function() { return /* reexport */ esm.sessionTimingIntegration; },
  "setContext": function() { return /* reexport */ esm.setContext; },
  "setCurrentClient": function() { return /* reexport */ esm.setCurrentClient; },
  "setExtra": function() { return /* reexport */ esm.setExtra; },
  "setExtras": function() { return /* reexport */ esm.setExtras; },
  "setHttpStatus": function() { return /* reexport */ esm.setHttpStatus; },
  "setMeasurement": function() { return /* reexport */ esm.setMeasurement; },
  "setTag": function() { return /* reexport */ esm.setTag; },
  "setTags": function() { return /* reexport */ esm.setTags; },
  "setUser": function() { return /* reexport */ esm.setUser; },
  "showReportDialog": function() { return /* reexport */ esm.showReportDialog; },
  "spanStatusfromHttpCode": function() { return /* reexport */ esm.spanStatusfromHttpCode; },
  "startBrowserTracingNavigationSpan": function() { return /* reexport */ esm.startBrowserTracingNavigationSpan; },
  "startBrowserTracingPageLoadSpan": function() { return /* reexport */ esm.startBrowserTracingPageLoadSpan; },
  "startInactiveSpan": function() { return /* reexport */ esm.startInactiveSpan; },
  "startSession": function() { return /* reexport */ esm.startSession; },
  "startSpan": function() { return /* reexport */ esm.startSpan; },
  "startSpanManual": function() { return /* reexport */ esm.startSpanManual; },
  "startTransaction": function() { return /* reexport */ esm.startTransaction; },
  "trace": function() { return /* reexport */ esm.trace; },
  "useProfiler": function() { return /* reexport */ useProfiler; },
  "winjsStackLineParser": function() { return /* reexport */ esm.winjsStackLineParser; },
  "withActiveSpan": function() { return /* reexport */ esm.withActiveSpan; },
  "withErrorBoundary": function() { return /* reexport */ withErrorBoundary; },
  "withIsolationScope": function() { return /* reexport */ esm.withIsolationScope; },
  "withProfiler": function() { return /* reexport */ withProfiler; },
  "withScope": function() { return /* reexport */ esm.withScope; },
  "withSentryConfig": function() { return /* reexport */ withSentryConfig; },
  "withSentryGetServerSideProps": function() { return /* reexport */ withSentryGetServerSideProps; },
  "withSentryGetStaticProps": function() { return /* reexport */ withSentryGetStaticProps; },
  "withSentryReactRouterV6Routing": function() { return /* reexport */ withSentryReactRouterV6Routing; },
  "withSentryRouting": function() { return /* reexport */ withSentryRouting; },
  "withSentryServerSideAppGetInitialProps": function() { return /* reexport */ withSentryServerSideAppGetInitialProps; },
  "withSentryServerSideDocumentGetInitialProps": function() { return /* reexport */ withSentryServerSideDocumentGetInitialProps; },
  "withSentryServerSideErrorGetInitialProps": function() { return /* reexport */ withSentryServerSideErrorGetInitialProps; },
  "withSentryServerSideGetInitialProps": function() { return /* reexport */ withSentryServerSideGetInitialProps; },
  "withServerActionInstrumentation": function() { return /* reexport */ withServerActionInstrumentation; },
  "wrap": function() { return /* reexport */ esm.wrap; },
  "wrapApiHandlerWithSentryVercelCrons": function() { return /* reexport */ wrapApiHandlerWithSentryVercelCrons; },
  "wrapAppGetInitialPropsWithSentry": function() { return /* reexport */ wrapAppGetInitialPropsWithSentry; },
  "wrapCreateBrowserRouter": function() { return /* reexport */ wrapCreateBrowserRouter; },
  "wrapDocumentGetInitialPropsWithSentry": function() { return /* reexport */ wrapDocumentGetInitialPropsWithSentry; },
  "wrapErrorGetInitialPropsWithSentry": function() { return /* reexport */ wrapErrorGetInitialPropsWithSentry; },
  "wrapGenerationFunctionWithSentry": function() { return /* reexport */ wrapGenerationFunctionWithSentry; },
  "wrapGetInitialPropsWithSentry": function() { return /* reexport */ wrapGetInitialPropsWithSentry; },
  "wrapGetServerSidePropsWithSentry": function() { return /* reexport */ wrapGetServerSidePropsWithSentry; },
  "wrapGetStaticPropsWithSentry": function() { return /* reexport */ wrapGetStaticPropsWithSentry; },
  "wrapMiddlewareWithSentry": function() { return /* reexport */ wrapMiddlewareWithSentry; },
  "wrapPageComponentWithSentry": function() { return /* reexport */ wrapPageComponentWithSentry; },
  "wrapRouteHandlerWithSentry": function() { return /* reexport */ wrapRouteHandlerWithSentry; },
  "wrapServerComponentWithSentry": function() { return /* reexport */ wrapServerComponentWithSentry; },
  "wrapUseRoutes": function() { return /* reexport */ wrapUseRoutes; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_instanceof.mjs
var _instanceof = __webpack_require__(82670);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var src_object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var src_object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(36305);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/sdkMetadata.js
var sdkMetadata = __webpack_require__(88633);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/index.js + 30 modules
var esm = __webpack_require__(21986);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/sdk.js
var sdk = __webpack_require__(26279);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/sdk.js



/**
 * Inits the React SDK
 */ function init(options) {
    var opts = (0,src_object_spread/* default */.Z)({}, options);
    (0,sdkMetadata/* applySdkMetadata */.V)(opts, "react");
    (0,sdk/* init */.S1)(opts);
}
 //# sourceMappingURL=sdk.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/exports.js
var esm_exports = __webpack_require__(77668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_class_call_check.mjs
var _class_call_check = __webpack_require__(51438);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_class.mjs
var _create_class = __webpack_require__(52951);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_inherits.mjs
var _inherits = __webpack_require__(28668);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_possible_constructor_return.mjs
var _possible_constructor_return = __webpack_require__(41357);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs
var src_sliced_to_array = __webpack_require__(10253);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_create_super.mjs + 1 modules
var _create_super = __webpack_require__(71418);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/trace.js
var trace = __webpack_require__(19381);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/spanUtils.js
var spanUtils = __webpack_require__(76190);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/time.js
var time = __webpack_require__(96233);
// EXTERNAL MODULE: ./node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.js
var hoist_non_react_statics_cjs = __webpack_require__(8679);
var hoist_non_react_statics_cjs_default = /*#__PURE__*/__webpack_require__.n(hoist_non_react_statics_cjs);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/constants.js
var REACT_RENDER_OP = "ui.react.render";
var REACT_UPDATE_OP = "ui.react.update";
var REACT_MOUNT_OP = "ui.react.mount";
 //# sourceMappingURL=constants.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/profiler.js














var _jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/profiler.tsx";
var UNKNOWN_COMPONENT = "unknown";
/**
 * The Profiler component leverages Sentry's Tracing integration to generate
 * spans based on component lifecycles.
 */ var Profiler = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(Profiler, _Component);
    var _super = (0,_create_super/* default */.Z)(Profiler);
    function Profiler(props) {
        (0,_class_call_check/* default */.Z)(this, Profiler);
        var _this;
        _this = _super.call(this, props);
        var _props = _this.props, name = _props.name, _disabled = _props.disabled, disabled = _disabled === void 0 ? false : _disabled;
        if (disabled) {
            return (0,_possible_constructor_return/* default */.Z)(_this);
        }
        _this._mountSpan = (0,trace/* startInactiveSpan */.qp)({
            name: "<".concat(name, ">"),
            onlyIfParent: true,
            op: REACT_MOUNT_OP,
            origin: "auto.ui.react.profiler",
            attributes: {
                "ui.component_name": name
            }
        });
        return _this;
    }
    (0,_create_class/* default */.Z)(Profiler, [
        {
            // If a component mounted, we can finish the mount activity.
            key: "componentDidMount",
            value: function componentDidMount() {
                if (this._mountSpan) {
                    this._mountSpan.end();
                }
            }
        },
        {
            key: "shouldComponentUpdate",
            value: function shouldComponentUpdate(param) {
                var updateProps = param.updateProps, _includeUpdates = param.includeUpdates, includeUpdates = _includeUpdates === void 0 ? true : _includeUpdates;
                var _this = this;
                // Only generate an update span if includeUpdates is true, if there is a valid mountSpan,
                // and if the updateProps have changed. It is ok to not do a deep equality check here as it is expensive.
                // We are just trying to give baseline clues for further investigation.
                if (includeUpdates && this._mountSpan && updateProps !== this.props.updateProps) {
                    // See what props haved changed between the previous props, and the current props. This is
                    // set as data on the span. We just store the prop keys as the values could be potenially very large.
                    var changedProps = Object.keys(updateProps).filter(function(k) {
                        return updateProps[k] !== _this.props.updateProps[k];
                    });
                    if (changedProps.length > 0) {
                        var now = (0,time/* timestampInSeconds */.ph)();
                        this._updateSpan = (0,esm_exports/* withActiveSpan */._d)(this._mountSpan, function() {
                            return (0,trace/* startInactiveSpan */.qp)({
                                name: "<".concat(_this.props.name, ">"),
                                onlyIfParent: true,
                                op: REACT_UPDATE_OP,
                                origin: "auto.ui.react.profiler",
                                startTimestamp: now,
                                attributes: {
                                    "ui.component_name": _this.props.name,
                                    "ui.react.changed_props": changedProps
                                }
                            });
                        });
                    }
                }
                return true;
            }
        },
        {
            key: "componentDidUpdate",
            value: function componentDidUpdate() {
                if (this._updateSpan) {
                    this._updateSpan.end();
                    this._updateSpan = undefined;
                }
            }
        },
        {
            // If a component is unmounted, we can say it is no longer on the screen.
            // This means we can finish the span representing the component render.
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var endTimestamp = (0,time/* timestampInSeconds */.ph)();
                var _props = this.props, name = _props.name, _includeRender = _props.includeRender, includeRender = _includeRender === void 0 ? true : _includeRender;
                if (this._mountSpan && includeRender) {
                    var startTimestamp = (0,spanUtils/* spanToJSON */.XU)(this._mountSpan).timestamp;
                    (0,esm_exports/* withActiveSpan */._d)(this._mountSpan, function() {
                        var renderSpan = (0,trace/* startInactiveSpan */.qp)({
                            onlyIfParent: true,
                            name: "<".concat(name, ">"),
                            op: REACT_RENDER_OP,
                            origin: "auto.ui.react.profiler",
                            startTimestamp: startTimestamp,
                            attributes: {
                                "ui.component_name": name
                            }
                        });
                        if (renderSpan) {
                            // Have to cast to Span because the type of _mountSpan is Span | undefined
                            // and not getting narrowed properly
                            renderSpan.end(endTimestamp);
                        }
                    });
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return this.props.children;
            }
        }
    ], [
        {
            key: "__initStatic",
            value: /**
   * The span of the mount activity
   * Made protected for the React Native SDK to access
   */ /**
   * The span that represents the duration of time between shouldComponentUpdate and componentDidUpdate
   */ // eslint-disable-next-line @typescript-eslint/member-ordering
            function __initStatic() {
                this.defaultProps = {
                    disabled: false,
                    includeRender: true,
                    includeUpdates: true
                };
            }
        }
    ]);
    return Profiler;
}(react.Component);
Profiler.__initStatic();
/**
 * withProfiler is a higher order component that wraps a
 * component in a {@link Profiler} component. It is recommended that
 * the higher order component be used over the regular {@link Profiler} component.
 *
 * @param WrappedComponent component that is wrapped by Profiler
 * @param options the {@link ProfilerProps} you can pass into the Profiler
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function withProfiler(WrappedComponent, // We do not want to have `updateProps` given in options, it is instead filled through the HOC.
options) {
    var _this = this;
    var componentDisplayName = options && options.name || WrappedComponent.displayName || WrappedComponent.name || UNKNOWN_COMPONENT;
    var Wrapped = function(props) {
        return /*#__PURE__*/ react.createElement(Profiler, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
            name: componentDisplayName,
            updateProps: props,
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 159
            }
        }), /*#__PURE__*/ react.createElement(WrappedComponent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            __self: _this,
            __source: {
                fileName: _jsxFileName,
                lineNumber: 160
            }
        })));
    };
    Wrapped.displayName = "profiler(".concat(componentDisplayName, ")");
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    hoist_non_react_statics_cjs_default()(Wrapped, WrappedComponent);
    return Wrapped;
}
/**
 *
 * `useProfiler` is a React hook that profiles a React component.
 *
 * Requires React 16.8 or above.
 * @param name displayName of component being profiled
 */ function useProfiler(name) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {
        disabled: false,
        hasRenderSpan: true
    };
    var ref = (0,src_sliced_to_array/* default */.Z)(react.useState(function() {
        if (options && options.disabled) {
            return undefined;
        }
        return (0,trace/* startInactiveSpan */.qp)({
            name: "<".concat(name, ">"),
            onlyIfParent: true,
            op: REACT_MOUNT_OP,
            origin: "auto.ui.react.profiler",
            attributes: {
                "ui.component_name": name
            }
        });
    }), 1), mountSpan = ref[0];
    react.useEffect(function() {
        if (mountSpan) {
            mountSpan.end();
        }
        return function() {
            if (mountSpan && options.hasRenderSpan) {
                var startTimestamp = (0,spanUtils/* spanToJSON */.XU)(mountSpan).timestamp;
                var endTimestamp = (0,time/* timestampInSeconds */.ph)();
                var renderSpan = (0,trace/* startInactiveSpan */.qp)({
                    name: "<".concat(name, ">"),
                    onlyIfParent: true,
                    op: REACT_RENDER_OP,
                    origin: "auto.ui.react.profiler",
                    startTimestamp: startTimestamp,
                    attributes: {
                        "ui.component_name": name
                    }
                });
                if (renderSpan) {
                    // Have to cast to Span because the type of _mountSpan is Span | undefined
                    // and not getting narrowed properly
                    renderSpan.end(endTimestamp);
                }
            }
        };
    // We only want this to run once.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
}
 //# sourceMappingURL=profiler.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_assert_this_initialized.mjs
var _assert_this_initialized = __webpack_require__(4111);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/is.js
var is = __webpack_require__(74020);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/logger.js
var logger = __webpack_require__(92957);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/debug-build.js
/**
 * This serves as a build time flag that will be true by default, but false in non-debug builds or if users replace `__SENTRY_DEBUG__` in their generated code.
 *
 * ATTENTION: This constant must never cross package boundaries (i.e. be exported) to guarantee that it can be used for tree shaking.
 */ var DEBUG_BUILD =  false || false;
 //# sourceMappingURL=debug-build.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/errorboundary.js












var errorboundary_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/errorboundary.tsx";
function isAtLeastReact17(version) {
    var major = version.match(/^([^.]+)/);
    return major !== null && parseInt(major[0]) >= 17;
}
var errorboundary_UNKNOWN_COMPONENT = "unknown";
var INITIAL_STATE = {
    componentStack: null,
    error: null,
    eventId: null
};
function setCause(error, cause) {
    var seenErrors = new WeakMap();
    function recurse(error, cause) {
        // If we've already seen the error, there is a recursive loop somewhere in the error's
        // cause chain. Let's just bail out then to prevent a stack overflow.
        if (seenErrors.has(error)) {
            return;
        }
        if (error.cause) {
            seenErrors.set(error, true);
            return recurse(error.cause, cause);
        }
        error.cause = cause;
    }
    recurse(error, cause);
}
/**
 * A ErrorBoundary component that logs errors to Sentry. Requires React >= 16.
 * NOTE: If you are a Sentry user, and you are seeing this stack frame, it means the
 * Sentry React SDK ErrorBoundary caught an error invoking your application code. This
 * is expected behavior and NOT indicative of a bug with the Sentry React SDK.
 */ var ErrorBoundary = /*#__PURE__*/ function(_Component) {
    "use strict";
    (0,_inherits/* default */.Z)(ErrorBoundary, _Component);
    var _super = (0,_create_super/* default */.Z)(ErrorBoundary);
    function ErrorBoundary(props) {
        (0,_class_call_check/* default */.Z)(this, ErrorBoundary);
        var _this;
        _this = _super.call(this, props);
        ErrorBoundary.prototype.__init.call((0,_assert_this_initialized/* default */.Z)(_this));
        _this.state = INITIAL_STATE;
        _this._openFallbackReportDialog = true;
        var client = (0,esm_exports/* getClient */.s3)();
        if (client && client.on && props.showDialog) {
            _this._openFallbackReportDialog = false;
            client.on("afterSendEvent", function(event) {
                if (!event.type && event.event_id === _this._lastEventId) {
                    // eslint-disable-next-line deprecation/deprecation
                    (0,sdk/* showReportDialog */.jp)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props.dialogOptions), {
                        eventId: _this._lastEventId
                    }));
                }
            });
        }
        return _this;
    }
    (0,_create_class/* default */.Z)(ErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, param) {
                var componentStack = param.componentStack;
                var _this = this;
                var _props = this.props, beforeCapture = _props.beforeCapture, onError = _props.onError, showDialog = _props.showDialog, dialogOptions = _props.dialogOptions;
                (0,esm_exports/* withScope */.$e)(function(scope) {
                    // If on React version >= 17, create stack trace from componentStack param and links
                    // to to the original error using `error.cause` otherwise relies on error param for stacktrace.
                    // Linking errors requires the `LinkedErrors` integration be enabled.
                    // See: https://reactjs.org/blog/2020/08/10/react-v17-rc.html#native-component-stacks
                    //
                    // Although `componentDidCatch` is typed to accept an `Error` object, it can also be invoked
                    // with non-error objects. This is why we need to check if the error is an error-like object.
                    // See: https://github.com/getsentry/sentry-javascript/issues/6167
                    if (isAtLeastReact17(react.version) && (0,is/* isError */.VZ)(error)) {
                        var errorBoundaryError = new Error(error.message);
                        errorBoundaryError.name = "React ErrorBoundary ".concat(error.name);
                        errorBoundaryError.stack = componentStack;
                        // Using the `LinkedErrors` integration to link the errors together.
                        setCause(error, errorBoundaryError);
                    }
                    if (beforeCapture) {
                        beforeCapture(scope, error, componentStack);
                    }
                    var eventId = (0,esm_exports/* captureException */.Tb)(error, {
                        captureContext: {
                            contexts: {
                                react: {
                                    componentStack: componentStack
                                }
                            }
                        },
                        // If users provide a fallback component we can assume they are handling the error.
                        // Therefore, we set the mechanism depending on the presence of the fallback prop.
                        mechanism: {
                            handled: !!_this.props.fallback
                        }
                    });
                    if (onError) {
                        onError(error, componentStack, eventId);
                    }
                    if (showDialog) {
                        _this._lastEventId = eventId;
                        if (_this._openFallbackReportDialog) {
                            (0,sdk/* showReportDialog */.jp)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, dialogOptions), {
                                eventId: eventId
                            }));
                        }
                    }
                    // componentDidCatch is used over getDerivedStateFromError
                    // so that componentStack is accessible through state.
                    _this.setState({
                        error: error,
                        componentStack: componentStack,
                        eventId: eventId
                    });
                });
            }
        },
        {
            key: "componentDidMount",
            value: function componentDidMount() {
                var onMount = this.props.onMount;
                if (onMount) {
                    onMount();
                }
            }
        },
        {
            key: "componentWillUnmount",
            value: function componentWillUnmount() {
                var _state = this.state, error = _state.error, componentStack = _state.componentStack, eventId = _state.eventId;
                var onUnmount = this.props.onUnmount;
                if (onUnmount) {
                    onUnmount(error, componentStack, eventId);
                }
            }
        },
        {
            key: "__init",
            value: function __init() {
                var _this = this;
                this.resetErrorBoundary = function() {
                    var onReset = _this.props.onReset;
                    var _state = _this.state, error = _state.error, componentStack = _state.componentStack, eventId = _state.eventId;
                    if (onReset) {
                        onReset(error, componentStack, eventId);
                    }
                    _this.setState(INITIAL_STATE);
                };
            }
        },
        {
            key: "render",
            value: function render() {
                var _props = this.props, fallback = _props.fallback, children = _props.children;
                var state = this.state;
                if (state.error) {
                    var element = undefined;
                    if (typeof fallback === "function") {
                        element = fallback({
                            error: state.error,
                            componentStack: state.componentStack,
                            resetError: this.resetErrorBoundary,
                            eventId: state.eventId
                        });
                    } else {
                        element = fallback;
                    }
                    if (/*#__PURE__*/ react.isValidElement(element)) {
                        return element;
                    }
                    if (fallback) {
                        DEBUG_BUILD && logger/* logger.warn */.kg.warn("fallback did not produce a valid ReactElement");
                    }
                    // Fail gracefully if no fallback provided or is not valid
                    return null;
                }
                if (typeof children === "function") {
                    return children();
                }
                return children;
            }
        }
    ]);
    return ErrorBoundary;
}(react.Component);
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorBoundary(WrappedComponent, errorBoundaryOptions) {
    var _this = this;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var componentDisplayName = WrappedComponent.displayName || WrappedComponent.name || errorboundary_UNKNOWN_COMPONENT;
    var Wrapped = function(props) {
        return /*#__PURE__*/ react.createElement(ErrorBoundary, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, errorBoundaryOptions), {
            __self: _this,
            __source: {
                fileName: errorboundary_jsxFileName,
                lineNumber: 240
            }
        }), /*#__PURE__*/ react.createElement(WrappedComponent, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            __self: _this,
            __source: {
                fileName: errorboundary_jsxFileName,
                lineNumber: 241
            }
        })));
    };
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    Wrapped.displayName = "errorBoundary(".concat(componentDisplayName, ")");
    // Copy over static methods from Wrapped component to Profiler HOC
    // See: https://reactjs.org/docs/higher-order-components.html#static-methods-must-be-copied-over
    hoist_non_react_statics_cjs_default()(Wrapped, WrappedComponent);
    return Wrapped;
}
 //# sourceMappingURL=errorboundary.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/scope.js
var scope = __webpack_require__(29791);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/object.js
var object = __webpack_require__(27389);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/redux.js




/* eslint-disable @typescript-eslint/no-explicit-any */ var ACTION_BREADCRUMB_CATEGORY = "redux.action";
var ACTION_BREADCRUMB_TYPE = "info";
var defaultOptions = {
    attachReduxState: true,
    actionTransformer: function(action) {
        return action;
    },
    stateTransformer: function(state) {
        return state || null;
    }
};
/**
 * Creates an enhancer that would be passed to Redux's createStore to log actions and the latest state to Sentry.
 *
 * @param enhancerOptions Options to pass to the enhancer
 */ function createReduxEnhancer(enhancerOptions) {
    // Note: We return an any type as to not have type conflicts.
    var options = (0,src_object_spread/* default */.Z)({}, defaultOptions, enhancerOptions);
    return function(next) {
        return function(reducer, initialState) {
            options.attachReduxState && (0,scope/* getGlobalScope */.lW)().addEventProcessor(function(event, hint) {
                try {
                    // @ts-expect-error try catch to reduce bundle size
                    if (event.type === undefined && event.contexts.state.state.type === "redux") {
                        hint.attachments = (0,_to_consumable_array/* default */.Z)(hint.attachments || []).concat([
                            // @ts-expect-error try catch to reduce bundle size
                            {
                                filename: "redux_state.json",
                                data: JSON.stringify(event.contexts.state.state.value)
                            }, 
                        ]);
                    }
                } catch (_) {
                // empty
                }
                return event;
            });
            var sentryReducer = function(state, action) {
                var newState = reducer(state, action);
                var scope = (0,esm_exports/* getCurrentScope */.nZ)();
                /* Action breadcrumbs */ var transformedAction = options.actionTransformer(action);
                if (typeof transformedAction !== "undefined" && transformedAction !== null) {
                    scope.addBreadcrumb({
                        category: ACTION_BREADCRUMB_CATEGORY,
                        data: transformedAction,
                        type: ACTION_BREADCRUMB_TYPE
                    });
                }
                /* Set latest state to scope */ var transformedState = options.stateTransformer(newState);
                if (typeof transformedState !== "undefined" && transformedState !== null) {
                    var client = (0,esm_exports/* getClient */.s3)();
                    var options1 = client && client.getOptions();
                    var normalizationDepth = options1 && options1.normalizeDepth || 3; // default state normalization depth to 3
                    // Set the normalization depth of the redux state to the configured `normalizeDepth` option or a sane number as a fallback
                    var newStateContext = {
                        state: {
                            type: "redux",
                            value: transformedState
                        }
                    };
                    (0,object/* addNonEnumerableProperty */.xp)(newStateContext, "__sentry_override_normalization_depth__", 3 + // 3 layers for `state.value.transformedState`
                    normalizationDepth);
                    scope.setContext("state", newStateContext);
                } else {
                    scope.setContext("state", null);
                }
                /* Allow user to configure scope with latest state */ var configureScopeWithState = options.configureScopeWithState;
                if (typeof configureScopeWithState === "function") {
                    configureScopeWithState(scope, newState);
                }
                return newState;
            };
            return next(sentryReducer, initialState);
        };
    };
}
 //# sourceMappingURL=redux.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browserTracingIntegration.js
var browserTracingIntegration = __webpack_require__(81610);
// EXTERNAL MODULE: ./node_modules/@sentry/browser/esm/helpers.js
var helpers = __webpack_require__(50203);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/semanticAttributes.js
var semanticAttributes = __webpack_require__(91292);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/reactrouterv3.js





// Many of the types below had to be mocked out to prevent typescript issues
// these types are required for correct functionality.
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function reactRouterV3BrowserTracingIntegration(options) {
    var integration = (0,browserTracingIntegration/* browserTracingIntegration */.E8)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
        instrumentPageLoad: false,
        instrumentNavigation: false
    }));
    var history = options.history, routes = options.routes, match = options.match, _instrumentPageLoad = options.instrumentPageLoad, instrumentPageLoad = _instrumentPageLoad === void 0 ? true : _instrumentPageLoad, _instrumentNavigation = options.instrumentNavigation, instrumentNavigation = _instrumentNavigation === void 0 ? true : _instrumentNavigation;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, integration), {
        afterAllSetup: function afterAllSetup(client) {
            integration.afterAllSetup(client);
            var startPageloadCallback = function(startSpanOptions) {
                (0,browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo)(client, startSpanOptions);
                return undefined;
            };
            var startNavigationCallback = function(startSpanOptions) {
                (0,browserTracingIntegration/* startBrowserTracingNavigationSpan */.og)(client, startSpanOptions);
                return undefined;
            };
            // eslint-disable-next-line deprecation/deprecation
            var instrumentation = reactRouterV3Instrumentation(history, routes, match);
            // Now instrument page load & navigation with correct settings
            instrumentation(startPageloadCallback, instrumentPageLoad, false);
            instrumentation(startNavigationCallback, false, instrumentNavigation);
        }
    });
}
/**
 * Creates routing instrumentation for React Router v3
 * Works for React Router >= 3.2.0 and < 4.0.0
 *
 * @param history object from the `history` library
 * @param routes a list of all routes, should be
 * @param match `Router.match` utility
 *
 * @deprecated Use `reactRouterV3BrowserTracingIntegration()` instead
 */ function reactRouterV3Instrumentation(history, routes, match) {
    return function(startTransaction) {
        var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var activeTransaction;
        var prevName;
        // Have to use window.location because history.location might not be defined.
        if (startTransactionOnPageLoad && helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location) {
            normalizeTransactionName(routes, helpers/* WINDOW.location */.m9.location, match, function(localName) {
                var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "url";
                prevName = localName;
                var _obj;
                activeTransaction = startTransaction({
                    name: prevName,
                    attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J, "pageload"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.pageload.react.reactrouter_v3"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, source), _obj)
                });
            });
        }
        if (startTransactionOnLocationChange && history.listen) {
            history.listen(function(location) {
                if (location.action === "PUSH" || location.action === "POP") {
                    if (activeTransaction) {
                        activeTransaction.end();
                    }
                    normalizeTransactionName(routes, location, match, function(localName) {
                        var source = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "url";
                        prevName = localName;
                        var _obj;
                        var attributes = (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J, "navigation"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.navigation.react.reactrouter_v3"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, source), _obj);
                        activeTransaction = startTransaction({
                            name: prevName,
                            attributes: attributes
                        });
                    });
                }
            });
        }
    };
}
/**
 * Normalize transaction names using `Router.match`
 */ function normalizeTransactionName(appRoutes, location, match, callback) {
    var name = location.pathname;
    match({
        location: location,
        routes: appRoutes
    }, function(error, _redirectLocation, renderProps) {
        if (error || !renderProps) {
            return callback(name);
        }
        var routePath = getRouteStringFromRoutes(renderProps.routes || []);
        if (routePath.length === 0 || routePath === "/*") {
            return callback(name);
        }
        name = routePath;
        return callback(name, "route");
    });
}
/**
 * Generate route name from array of routes
 */ function getRouteStringFromRoutes(routes) {
    if (!Array.isArray(routes) || routes.length === 0) {
        return "";
    }
    var routesWithPaths = routes.filter(function(route) {
        return !!route.path;
    });
    var index = -1;
    for(var x = routesWithPaths.length - 1; x >= 0; x--){
        var route = routesWithPaths[x];
        if (route.path && route.path.startsWith("/")) {
            index = x;
            break;
        }
    }
    return routesWithPaths.slice(index).filter(function(param) {
        var path = param.path;
        return !!path;
    }).map(function(param) {
        var path = param.path;
        return path;
    }).join("");
}
 //# sourceMappingURL=reactrouterv3.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/getRootSpan.js
var getRootSpan = __webpack_require__(27606);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/reactrouter.js








var reactrouter_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouter.tsx";
// We need to disable eslint no-explict-any because any is required for the
// react-router typings.
var activeTransaction;
/**
 * A browser tracing integration that uses React Router v4 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function reactRouterV4BrowserTracingIntegration(options) {
    var integration = (0,browserTracingIntegration/* browserTracingIntegration */.E8)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
        instrumentPageLoad: false,
        instrumentNavigation: false
    }));
    var history = options.history, routes = options.routes, matchPath = options.matchPath, _instrumentPageLoad = options.instrumentPageLoad, instrumentPageLoad = _instrumentPageLoad === void 0 ? true : _instrumentPageLoad, _instrumentNavigation = options.instrumentNavigation, instrumentNavigation = _instrumentNavigation === void 0 ? true : _instrumentNavigation;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, integration), {
        afterAllSetup: function afterAllSetup(client) {
            integration.afterAllSetup(client);
            var startPageloadCallback = function(startSpanOptions) {
                (0,browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo)(client, startSpanOptions);
                return undefined;
            };
            var startNavigationCallback = function(startSpanOptions) {
                (0,browserTracingIntegration/* startBrowserTracingNavigationSpan */.og)(client, startSpanOptions);
                return undefined;
            };
            // eslint-disable-next-line deprecation/deprecation
            var instrumentation = reactRouterV4Instrumentation(history, routes, matchPath);
            // Now instrument page load & navigation with correct settings
            instrumentation(startPageloadCallback, instrumentPageLoad, false);
            instrumentation(startNavigationCallback, false, instrumentNavigation);
        }
    });
}
/**
 * A browser tracing integration that uses React Router v5 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function reactRouterV5BrowserTracingIntegration(options) {
    var integration = (0,browserTracingIntegration/* browserTracingIntegration */.E8)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
        instrumentPageLoad: false,
        instrumentNavigation: false
    }));
    var history = options.history, routes = options.routes, matchPath = options.matchPath;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, integration), {
        afterAllSetup: function afterAllSetup(client) {
            integration.afterAllSetup(client);
            var startPageloadCallback = function(startSpanOptions) {
                (0,browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo)(client, startSpanOptions);
                return undefined;
            };
            var startNavigationCallback = function(startSpanOptions) {
                (0,browserTracingIntegration/* startBrowserTracingNavigationSpan */.og)(client, startSpanOptions);
                return undefined;
            };
            // eslint-disable-next-line deprecation/deprecation
            var instrumentation = reactRouterV5Instrumentation(history, routes, matchPath);
            // Now instrument page load & navigation with correct settings
            instrumentation(startPageloadCallback, options.instrumentPageLoad, false);
            instrumentation(startNavigationCallback, false, options.instrumentNavigation);
        }
    });
}
/**
 * @deprecated Use `browserTracingReactRouterV4()` instead.
 */ function reactRouterV4Instrumentation(history, routes, matchPath) {
    return createReactRouterInstrumentation(history, "reactrouter_v4", routes, matchPath);
}
/**
 * @deprecated Use `browserTracingReactRouterV5()` instead.
 */ function reactRouterV5Instrumentation(history, routes, matchPath) {
    return createReactRouterInstrumentation(history, "reactrouter_v5", routes, matchPath);
}
function createReactRouterInstrumentation(history, instrumentationName) {
    var allRoutes = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], matchPath = arguments.length > 3 ? arguments[3] : void 0;
    var getInitPathName = function getInitPathName() {
        if (history && history.location) {
            return history.location.pathname;
        }
        if (helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location) {
            return helpers/* WINDOW.location.pathname */.m9.location.pathname;
        }
        return undefined;
    };
    var normalizeTransactionName = /**
   * Normalizes a transaction name. Returns the new name as well as the
   * source of the transaction.
   *
   * @param pathname The initial pathname we normalize
   */ function normalizeTransactionName(pathname) {
        if (allRoutes.length === 0 || !matchPath) {
            return [
                pathname,
                "url"
            ];
        }
        var branches = matchRoutes(allRoutes, pathname, matchPath);
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var x = 0; x < branches.length; x++){
            if (branches[x].match.isExact) {
                return [
                    branches[x].match.path,
                    "route"
                ];
            }
        }
        return [
            pathname,
            "url"
        ];
    };
    return function(customStartTransaction) {
        var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var initPathName = getInitPathName();
        if (startTransactionOnPageLoad && initPathName) {
            var ref = (0,src_sliced_to_array/* default */.Z)(normalizeTransactionName(initPathName), 2), name = ref[0], source = ref[1];
            var _obj;
            activeTransaction = customStartTransaction({
                name: name,
                attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J, "pageload"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.pageload.react.".concat(instrumentationName)), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, source), _obj)
            });
        }
        if (startTransactionOnLocationChange && history.listen) {
            history.listen(function(location, action) {
                if (action && (action === "PUSH" || action === "POP")) {
                    if (activeTransaction) {
                        activeTransaction.end();
                    }
                    var ref = (0,src_sliced_to_array/* default */.Z)(normalizeTransactionName(location.pathname), 2), name = ref[0], source = ref[1];
                    var _obj;
                    activeTransaction = customStartTransaction({
                        name: name,
                        attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J, "navigation"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.navigation.react.".concat(instrumentationName)), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, source), _obj)
                    });
                }
            });
        }
    };
}
/**
 * Matches a set of routes to a pathname
 * Based on implementation from
 */ function matchRoutes(routes, pathname, matchPath) {
    var branch = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : [];
    routes.some(function(route) {
        var match = route.path ? matchPath(pathname, route) : branch.length ? branch[branch.length - 1].match // use parent match
         : computeRootMatch(pathname); // use default "root" match
        if (match) {
            branch.push({
                route: route,
                match: match
            });
            if (route.routes) {
                matchRoutes(route.routes, pathname, matchPath, branch);
            }
        }
        return !!match;
    });
    return branch;
}
function computeRootMatch(pathname) {
    return {
        path: "/",
        url: "/",
        params: {},
        isExact: pathname === "/"
    };
}
/* eslint-disable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ function withSentryRouting(Route) {
    var _this = this;
    var componentDisplayName = Route.displayName || Route.name;
    var WrappedRoute = function(props) {
        if (props && props.computedMatch && props.computedMatch.isExact) {
            var route = props.computedMatch.path;
            var activeRootSpan = getActiveRootSpan();
            if (activeRootSpan) {
                activeRootSpan.updateName(route);
                activeRootSpan.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, "route");
            }
        }
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params:
        // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
        return /*#__PURE__*/ react.createElement(Route, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            __self: _this,
            __source: {
                fileName: reactrouter_jsxFileName,
                lineNumber: 279
            }
        }));
    };
    WrappedRoute.displayName = "sentryRoute(".concat(componentDisplayName, ")");
    hoist_non_react_statics_cjs_default()(WrappedRoute, Route);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params:
    // https://github.com/DefinitelyTyped/DefinitelyTyped/blob/13dc4235c069e25fe7ee16e11f529d909f9f3ff8/types/react-router/index.d.ts#L154-L164
    return WrappedRoute;
}
/* eslint-enable @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access */ function getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if (activeTransaction) {
        return activeTransaction;
    }
    var span = (0,trace/* getActiveSpan */.HN)();
    var rootSpan = span ? (0,getRootSpan/* getRootSpan */.G)(span) : undefined;
    if (!rootSpan) {
        return undefined;
    }
    var op = (0,spanUtils/* spanToJSON */.XU)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}
 //# sourceMappingURL=reactrouter.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/url.js
var url = __webpack_require__(57323);
;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/reactrouterv6.js










var reactrouterv6_jsxFileName = "/home/runner/work/sentry-javascript/sentry-javascript/packages/react/src/reactrouterv6.tsx"; /* eslint-disable max-lines */ 
var reactrouterv6_activeTransaction;
var _useEffect;
var _useLocation;
var _useNavigationType;
var _createRoutesFromChildren;
var _matchRoutes;
var _customStartTransaction;
var _startTransactionOnLocationChange;
var _stripBasename = false;
/**
 * A browser tracing integration that uses React Router v3 to instrument navigations.
 * Expects `history` (and optionally `routes` and `matchPath`) to be passed as options.
 */ function reactRouterV6BrowserTracingIntegration(options) {
    var integration = (0,browserTracingIntegration/* browserTracingIntegration */.E8)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, options), {
        instrumentPageLoad: false,
        instrumentNavigation: false
    }));
    var useEffect = options.useEffect, useLocation = options.useLocation, useNavigationType = options.useNavigationType, createRoutesFromChildren = options.createRoutesFromChildren, matchRoutes = options.matchRoutes, stripBasename = options.stripBasename, _instrumentPageLoad = options.instrumentPageLoad, instrumentPageLoad = _instrumentPageLoad === void 0 ? true : _instrumentPageLoad, _instrumentNavigation = options.instrumentNavigation, instrumentNavigation = _instrumentNavigation === void 0 ? true : _instrumentNavigation;
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, integration), {
        afterAllSetup: function afterAllSetup(client) {
            integration.afterAllSetup(client);
            var startNavigationCallback = function(startSpanOptions) {
                (0,browserTracingIntegration/* startBrowserTracingNavigationSpan */.og)(client, startSpanOptions);
                return undefined;
            };
            var initPathName = helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location && helpers/* WINDOW.location.pathname */.m9.location.pathname;
            if (instrumentPageLoad && initPathName) {
                var _obj;
                (0,browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo)(client, {
                    name: initPathName,
                    attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, "url"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J, "pageload"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.pageload.react.reactrouter_v6"), _obj)
                });
            }
            _useEffect = useEffect;
            _useLocation = useLocation;
            _useNavigationType = useNavigationType;
            _matchRoutes = matchRoutes;
            _createRoutesFromChildren = createRoutesFromChildren;
            _stripBasename = stripBasename || false;
            _customStartTransaction = startNavigationCallback;
            _startTransactionOnLocationChange = instrumentNavigation;
        }
    });
}
/**
 * @deprecated Use `reactRouterV6BrowserTracingIntegration()` instead.
 */ function reactRouterV6Instrumentation(useEffect, useLocation, useNavigationType, createRoutesFromChildren, matchRoutes, stripBasename) {
    return function(customStartTransaction) {
        var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        var initPathName = helpers/* WINDOW */.m9 && helpers/* WINDOW.location */.m9.location && helpers/* WINDOW.location.pathname */.m9.location.pathname;
        if (startTransactionOnPageLoad && initPathName) {
            var _obj;
            reactrouterv6_activeTransaction = customStartTransaction({
                name: initPathName,
                attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, "url"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J, "pageload"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.pageload.react.reactrouter_v6"), _obj)
            });
        }
        _useEffect = useEffect;
        _useLocation = useLocation;
        _useNavigationType = useNavigationType;
        _matchRoutes = matchRoutes;
        _createRoutesFromChildren = createRoutesFromChildren;
        _stripBasename = stripBasename || false;
        _customStartTransaction = customStartTransaction;
        _startTransactionOnLocationChange = startTransactionOnLocationChange;
    };
}
/**
 * Strip the basename from a pathname if exists.
 *
 * Vendored and modified from `react-router`
 * https://github.com/remix-run/react-router/blob/462bb712156a3f739d6139a0f14810b76b002df6/packages/router/utils.ts#L1038
 */ function stripBasenameFromPathname(pathname, basename) {
    if (!basename || basename === "/") {
        return pathname;
    }
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) {
        return pathname;
    }
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") {
        // pathname does not start with basename/
        return pathname;
    }
    return pathname.slice(startIndex) || "/";
}
function getNormalizedName(routes, location, branches) {
    var basename = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "";
    if (!routes || routes.length === 0) {
        return [
            _stripBasename ? stripBasenameFromPathname(location.pathname, basename) : location.pathname,
            "url"
        ];
    }
    var pathBuilder = "";
    if (branches) {
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for(var x = 0; x < branches.length; x++){
            var branch = branches[x];
            var route = branch.route;
            if (route) {
                // Early return if index route
                if (route.index) {
                    return [
                        _stripBasename ? stripBasenameFromPathname(branch.pathname, basename) : branch.pathname,
                        "route"
                    ];
                }
                var path = route.path;
                if (path) {
                    var newPath = path[0] === "/" || pathBuilder[pathBuilder.length - 1] === "/" ? path : "/".concat(path);
                    pathBuilder += newPath;
                    if (basename + branch.pathname === location.pathname) {
                        if (// If the route defined on the element is something like
                        // <Route path="/stores/:storeId/products/:productId" element={<div>Product</div>} />
                        // We should check against the branch.pathname for the number of / seperators
                        (0,url/* getNumberOfUrlSegments */.$A)(pathBuilder) !== (0,url/* getNumberOfUrlSegments */.$A)(branch.pathname) && // We should not count wildcard operators in the url segments calculation
                        pathBuilder.slice(-2) !== "/*") {
                            return [
                                (_stripBasename ? "" : basename) + newPath,
                                "route"
                            ];
                        }
                        return [
                            (_stripBasename ? "" : basename) + pathBuilder,
                            "route"
                        ];
                    }
                }
            }
        }
    }
    return [
        _stripBasename ? stripBasenameFromPathname(location.pathname, basename) : location.pathname,
        "url"
    ];
}
function updatePageloadTransaction(activeRootSpan, location, routes, matches, basename) {
    var branches = Array.isArray(matches) ? matches : _matchRoutes(routes, location, basename);
    if (activeRootSpan && branches) {
        var ref = (0,src_sliced_to_array/* default */.Z)(getNormalizedName(routes, location, branches, basename), 2), name = ref[0], source = ref[1];
        activeRootSpan.updateName(name);
        activeRootSpan.setAttribute(semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, source);
    }
}
function handleNavigation(location, routes, navigationType, matches, basename) {
    var branches = Array.isArray(matches) ? matches : _matchRoutes(routes, location, basename);
    if (_startTransactionOnLocationChange && (navigationType === "PUSH" || navigationType === "POP") && branches) {
        if (reactrouterv6_activeTransaction) {
            reactrouterv6_activeTransaction.end();
        }
        var ref = (0,src_sliced_to_array/* default */.Z)(getNormalizedName(routes, location, branches, basename), 2), name = ref[0], source = ref[1];
        var _obj;
        reactrouterv6_activeTransaction = _customStartTransaction({
            name: name,
            attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, source), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_OP */.$J, "navigation"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.navigation.react.reactrouter_v6"), _obj)
        });
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function withSentryReactRouterV6Routing(Routes) {
    var _this = this;
    if (!_useEffect || !_useLocation || !_useNavigationType || !_createRoutesFromChildren || !_matchRoutes || !_customStartTransaction) {
        DEBUG_BUILD && logger/* logger.warn */.kg.warn("reactRouterV6Instrumentation was unable to wrap Routes because of one or more missing parameters.\n      useEffect: ".concat(_useEffect, ". useLocation: ").concat(_useLocation, ". useNavigationType: ").concat(_useNavigationType, ".\n      createRoutesFromChildren: ").concat(_createRoutesFromChildren, ". matchRoutes: ").concat(_matchRoutes, ". customStartTransaction: ").concat(_customStartTransaction, "."));
        return Routes;
    }
    var isMountRenderPass = true;
    var SentryRoutes = function(props) {
        var location = _useLocation();
        var navigationType = _useNavigationType();
        _useEffect(function() {
            var routes = _createRoutesFromChildren(props.children);
            if (isMountRenderPass) {
                updatePageloadTransaction(reactrouterv6_getActiveRootSpan(), location, routes);
                isMountRenderPass = false;
            } else {
                handleNavigation(location, routes, navigationType);
            }
        }, // `props.children` is purpusely not included in the dependency array, because we do not want to re-run this effect
        // when the children change. We only want to start transactions when the location or navigation type change.
        [
            location,
            navigationType
        ]);
        // @ts-expect-error Setting more specific React Component typing for `R` generic above
        // will break advanced type inference done by react router params
        return /*#__PURE__*/ react.createElement(Routes, (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, props), {
            __self: _this,
            __source: {
                fileName: reactrouterv6_jsxFileName,
                lineNumber: 329
            }
        }));
    };
    hoist_non_react_statics_cjs_default()(SentryRoutes, Routes);
    // @ts-expect-error Setting more specific React Component typing for `R` generic above
    // will break advanced type inference done by react router params
    return SentryRoutes;
}
function wrapUseRoutes(origUseRoutes) {
    var _this = this;
    if (!_useEffect || !_useLocation || !_useNavigationType || !_matchRoutes || !_customStartTransaction) {
        DEBUG_BUILD && logger/* logger.warn */.kg.warn("reactRouterV6Instrumentation was unable to wrap `useRoutes` because of one or more missing parameters.");
        return origUseRoutes;
    }
    var isMountRenderPass = true;
    var SentryRoutes = function(props) {
        var routes = props.routes, locationArg = props.locationArg;
        var Routes = origUseRoutes(routes, locationArg);
        var location = _useLocation();
        var navigationType = _useNavigationType();
        // A value with stable identity to either pick `locationArg` if available or `location` if not
        var stableLocationParam = typeof locationArg === "string" || locationArg && locationArg.pathname ? locationArg : location;
        _useEffect(function() {
            var normalizedLocation = typeof stableLocationParam === "string" ? {
                pathname: stableLocationParam
            } : stableLocationParam;
            if (isMountRenderPass) {
                updatePageloadTransaction(reactrouterv6_getActiveRootSpan(), normalizedLocation, routes);
                isMountRenderPass = false;
            } else {
                handleNavigation(normalizedLocation, routes, navigationType);
            }
        }, [
            navigationType,
            stableLocationParam
        ]);
        return Routes;
    };
    // eslint-disable-next-line react/display-name
    return function(routes, locationArg) {
        return /*#__PURE__*/ react.createElement(SentryRoutes, {
            routes: routes,
            locationArg: locationArg,
            __self: _this,
            __source: {
                fileName: reactrouterv6_jsxFileName,
                lineNumber: 386
            }
        });
    };
}
function wrapCreateBrowserRouter(createRouterFunction) {
    // `opts` for createBrowserHistory and createMemoryHistory are different, but also not relevant for us at the moment.
    // `basename` is the only option that is relevant for us, and it is the same for all.
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function(routes, opts) {
        var router = createRouterFunction(routes, opts);
        var basename = opts && opts.basename;
        var activeRootSpan = reactrouterv6_getActiveRootSpan();
        // The initial load ends when `createBrowserRouter` is called.
        // This is the earliest convenient time to update the transaction name.
        // Callbacks to `router.subscribe` are not called for the initial load.
        if (router.state.historyAction === "POP" && activeRootSpan) {
            updatePageloadTransaction(activeRootSpan, router.state.location, routes, undefined, basename);
        }
        router.subscribe(function(state) {
            var location = state.location;
            if (_startTransactionOnLocationChange && (state.historyAction === "PUSH" || state.historyAction === "POP")) {
                handleNavigation(location, routes, state.historyAction, undefined, basename);
            }
        });
        return router;
    };
}
function reactrouterv6_getActiveRootSpan() {
    // Legacy behavior for "old" react router instrumentation
    if (reactrouterv6_activeTransaction) {
        return reactrouterv6_activeTransaction;
    }
    var span = (0,trace/* getActiveSpan */.HN)();
    var rootSpan = span ? (0,getRootSpan/* getRootSpan */.G)(span) : undefined;
    if (!rootSpan) {
        return undefined;
    }
    var op = (0,spanUtils/* spanToJSON */.XU)(rootSpan).op;
    // Only use this root span if it is a pageload or navigation span
    return op === "navigation" || op === "pageload" ? rootSpan : undefined;
}
 //# sourceMappingURL=reactrouterv6.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/react/esm/index.js







 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/getVercelEnv.js
/* provided dependency */ var process = __webpack_require__(34155);
/**
 * Returns an environment setting value determined by Vercel's `VERCEL_ENV` environment variable.
 *
 * @param isClient Flag to indicate whether to use the `NEXT_PUBLIC_` prefixed version of the environment variable.
 */ function getVercelEnv(isClient) {
    var vercelEnvVar = isClient ? process.env.NEXT_PUBLIC_VERCEL_ENV : process.env.VERCEL_ENV;
    return vercelEnvVar ? "vercel-".concat(vercelEnvVar) : undefined;
}
 //# sourceMappingURL=getVercelEnv.js.map

// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/request.js + 1 modules
var request = __webpack_require__(24366);
// EXTERNAL MODULE: ./node_modules/@sentry-internal/tracing/esm/browser/browsertracing.js + 1 modules
var browsertracing = __webpack_require__(87097);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/instrument/fetch.js
var fetch = __webpack_require__(99096);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/appRouterRoutingInstrumentation.js




var DEFAULT_TAGS = {
    "routing.instrumentation": "next-app-router"
};
/**
 * Instruments the Next.js Client App Router.
 */ // TODO(v8): Clean this function up by splitting into pageload and navigation instrumentation respectively. Also remove startTransactionCb in the process.
function appRouterInstrumentation(startTransactionCb) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, startPageloadSpanCallback = arguments.length > 3 ? arguments[3] : void 0, startNavigationSpanCallback = arguments.length > 4 ? arguments[4] : void 0;
    // We keep track of the active transaction so we can finish it when we start a navigation transaction.
    var activeTransaction = undefined;
    // We keep track of the previous location name so we can set the `from` field on navigation transactions.
    // This is either a route or a pathname.
    var prevLocationName = helpers/* WINDOW.location.pathname */.m9.location.pathname;
    if (startTransactionOnPageLoad) {
        var transactionContext = {
            name: prevLocationName,
            op: "pageload",
            origin: "auto.pageload.nextjs.app_router_instrumentation",
            tags: DEFAULT_TAGS,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTimestamp: time/* browserPerformanceTimeOrigin */.Z1 ? time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined,
            metadata: {
                source: "url"
            }
        };
        activeTransaction = startTransactionCb(transactionContext);
        startPageloadSpanCallback(transactionContext);
    }
    if (startTransactionOnLocationChange) {
        (0,fetch/* addFetchInstrumentationHandler */.U)(function(handlerData) {
            // The instrumentation handler is invoked twice - once for starting a request and once when the req finishes
            // We can use the existence of the end-timestamp to filter out "finishing"-events.
            if (handlerData.endTimestamp !== undefined) {
                return;
            }
            // Only GET requests can be navigating RSC requests
            if (handlerData.fetchData.method !== "GET") {
                return;
            }
            var parsedNavigatingRscFetchArgs = parseNavigatingRscFetchArgs(handlerData.args);
            if (parsedNavigatingRscFetchArgs === null) {
                return;
            }
            var transactionName = parsedNavigatingRscFetchArgs.targetPathname;
            var tags = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, DEFAULT_TAGS), {
                from: prevLocationName
            });
            prevLocationName = transactionName;
            if (activeTransaction) {
                activeTransaction.end();
            }
            var transactionContext = {
                name: transactionName,
                op: "navigation",
                origin: "auto.navigation.nextjs.app_router_instrumentation",
                tags: tags,
                metadata: {
                    source: "url"
                }
            };
            startTransactionCb(transactionContext);
            startNavigationSpanCallback(transactionContext);
        });
    }
}
function parseNavigatingRscFetchArgs(fetchArgs) {
    // Make sure the first arg is a URL object
    if (!fetchArgs[0] || typeof fetchArgs[0] !== "object" || fetchArgs[0].searchParams === undefined) {
        return null;
    }
    // Make sure the second argument is some kind of fetch config obj that contains headers
    if (!fetchArgs[1] || typeof fetchArgs[1] !== "object" || !("headers" in fetchArgs[1])) {
        return null;
    }
    try {
        var url = fetchArgs[0];
        var headers = fetchArgs[1].headers;
        // Not an RSC request
        if (headers["RSC"] !== "1") {
            return null;
        }
        // Prefetch requests are not navigating RSC requests
        if (headers["Next-Router-Prefetch"] === "1") {
            return null;
        }
        return {
            targetPathname: url.pathname
        };
    } catch (e) {
        return null;
    }
}
 //# sourceMappingURL=appRouterRoutingInstrumentation.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/tracing.js
var tracing = __webpack_require__(84907);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/esm/common/debug-build.js
var debug_build = __webpack_require__(46748);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/pagesRouterRoutingInstrumentation.js







var globalObject = helpers/* WINDOW */.m9;
/**
 * Every Next.js page (static and dynamic ones) comes with a script tag with the id "__NEXT_DATA__". This script tag
 * contains a JSON object with data that was either generated at build time for static pages (`getStaticProps`), or at
 * runtime with data fetchers like `getServerSideProps.`.
 *
 * We can use this information to:
 * - Always get the parameterized route we're in when loading a page.
 * - Send trace information (trace-id, baggage) from the server to the client.
 *
 * This function extracts this information.
 */ function extractNextDataTagInformation() {
    var nextData;
    // Let's be on the safe side and actually check first if there is really a __NEXT_DATA__ script tag on the page.
    // Theoretically this should always be the case though.
    var nextDataTag = globalObject.document.getElementById("__NEXT_DATA__");
    if (nextDataTag && nextDataTag.innerHTML) {
        try {
            nextData = JSON.parse(nextDataTag.innerHTML);
        } catch (e) {
            debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("Could not extract __NEXT_DATA__");
        }
    }
    if (!nextData) {
        return {};
    }
    var nextDataTagInfo = {};
    var page = nextData.page, query = nextData.query, props = nextData.props;
    // `nextData.page` always contains the parameterized route - except for when an error occurs in a data fetching
    // function, then it is "/_error", but that isn't a problem since users know which route threw by looking at the
    // parent transaction
    // TODO: Actually this is a problem (even though it is not that big), because the DSC and the transaction payload will contain
    // a different transaction name. Maybe we can fix this. Idea: Also send transaction name via pageProps when available.
    nextDataTagInfo.route = page;
    nextDataTagInfo.params = query;
    if (props && props.pageProps) {
        nextDataTagInfo.sentryTrace = props.pageProps._sentryTraceData;
        nextDataTagInfo.baggage = props.pageProps._sentryBaggage;
    }
    return nextDataTagInfo;
}
var pagesRouterRoutingInstrumentation_DEFAULT_TAGS = {
    "routing.instrumentation": "next-pages-router"
};
// We keep track of the active transaction so we can finish it when we start a navigation transaction.
var pagesRouterRoutingInstrumentation_activeTransaction = undefined;
// We keep track of the previous location name so we can set the `from` field on navigation transactions.
// This is either a route or a pathname.
var prevLocationName = undefined;
var client = (0,esm_exports/* getClient */.s3)();
/**
 * Instruments the Next.js pages router. Only supported for
 * client side routing. Works for Next >= 10.
 *
 * Leverages the SingletonRouter from the `next/router` to
 * generate pageload/navigation transactions and parameterize
 * transaction names.
 */ function pagesRouterInstrumentation(startTransactionCb) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, startPageloadSpanCallback = arguments.length > 3 ? arguments[3] : void 0, startNavigationSpanCallback = arguments.length > 4 ? arguments[4] : void 0;
    var ref = extractNextDataTagInformation(), route = ref.route, params = ref.params, sentryTrace = ref.sentryTrace, baggage = ref.baggage;
    // eslint-disable-next-line deprecation/deprecation
    var ref1 = (0,tracing/* tracingContextFromHeaders */.KA)(sentryTrace, baggage), traceparentData = ref1.traceparentData, dynamicSamplingContext = ref1.dynamicSamplingContext, propagationContext = ref1.propagationContext;
    (0,esm_exports/* getCurrentScope */.nZ)().setPropagationContext(propagationContext);
    prevLocationName = route || globalObject.location.pathname;
    if (startTransactionOnPageLoad) {
        var source = route ? "route" : "url";
        var transactionContext = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
            name: prevLocationName,
            op: "pageload",
            origin: "auto.pageload.nextjs.pages_router_instrumentation",
            tags: pagesRouterRoutingInstrumentation_DEFAULT_TAGS,
            // pageload should always start at timeOrigin (and needs to be in s, not ms)
            startTimestamp: time/* browserPerformanceTimeOrigin */.Z1 ? time/* browserPerformanceTimeOrigin */.Z1 / 1000 : undefined
        }, params && client && client.getOptions().sendDefaultPii && {
            data: params
        }, traceparentData), {
            metadata: {
                source: source,
                dynamicSamplingContext: traceparentData && !dynamicSamplingContext ? {} : dynamicSamplingContext
            }
        });
        pagesRouterRoutingInstrumentation_activeTransaction = startTransactionCb(transactionContext);
        startPageloadSpanCallback(transactionContext);
    }
    if (startTransactionOnLocationChange) {
        router_default().events.on("routeChangeStart", function(navigationTarget) {
            var strippedNavigationTarget = (0,url/* stripUrlQueryAndFragment */.rt)(navigationTarget);
            var matchedRoute = getNextRouteFromPathname(strippedNavigationTarget);
            var transactionName;
            var transactionSource;
            if (matchedRoute) {
                transactionName = matchedRoute;
                transactionSource = "route";
            } else {
                transactionName = strippedNavigationTarget;
                transactionSource = "url";
            }
            var tags = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, pagesRouterRoutingInstrumentation_DEFAULT_TAGS), {
                from: prevLocationName
            });
            prevLocationName = transactionName;
            if (pagesRouterRoutingInstrumentation_activeTransaction) {
                pagesRouterRoutingInstrumentation_activeTransaction.end();
            }
            var transactionContext = {
                name: transactionName,
                op: "navigation",
                origin: "auto.navigation.nextjs.pages_router_instrumentation",
                tags: tags,
                metadata: {
                    source: transactionSource
                }
            };
            var navigationTransaction = startTransactionCb(transactionContext);
            startNavigationSpanCallback(transactionContext);
            if (navigationTransaction) {
                // In addition to the navigation transaction we're also starting a span to mark Next.js's `routeChangeStart`
                // and `routeChangeComplete` events.
                // We don't want to finish the navigation transaction on `routeChangeComplete`, since users might want to attach
                // spans to that transaction even after `routeChangeComplete` is fired (eg. HTTP requests in some useEffect
                // hooks). Instead, we'll simply let the navigation transaction finish itself (it's an `IdleTransaction`).
                // eslint-disable-next-line deprecation/deprecation
                var nextRouteChangeSpan = navigationTransaction.startChild({
                    op: "ui.nextjs.route-change",
                    origin: "auto.ui.nextjs.pages_router_instrumentation",
                    description: "Next.js Route Change"
                });
                var finishRouteChangeSpan = function() {
                    nextRouteChangeSpan.end();
                    router_default().events.off("routeChangeComplete", finishRouteChangeSpan);
                };
                router_default().events.on("routeChangeComplete", finishRouteChangeSpan);
            }
        });
    }
}
function getNextRouteFromPathname(pathname) {
    var pageRoutes = (globalObject.__BUILD_MANIFEST || {}).sortedPages;
    // Page route should in 99.999% of the cases be defined by now but just to be sure we make a check here
    if (!pageRoutes) {
        return;
    }
    return pageRoutes.find(function(route) {
        var routeRegExp = convertNextRouteToRegExp(route);
        return pathname.match(routeRegExp);
    });
}
/**
 * Converts a Next.js style route to a regular expression that matches on pathnames (no query params or URL fragments).
 *
 * In general this involves replacing any instances of square brackets in a route with a wildcard:
 * e.g. "/users/[id]/info" becomes /\/users\/([^/]+?)\/info/
 *
 * Some additional edgecases need to be considered:
 * - All routes have an optional slash at the end, meaning users can navigate to "/users/[id]/info" or
 *   "/users/[id]/info/" - both will be resolved to "/users/[id]/info".
 * - Non-optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[...params]").
 * - Optional "catchall"s at the end of a route must be considered when matching (e.g. "/users/[[...params]]").
 *
 * @param route A Next.js style route as it is found in `global.__BUILD_MANIFEST.sortedPages`
 */ function convertNextRouteToRegExp(route) {
    // We can assume a route is at least "/".
    var routeParts = route.split("/");
    var optionalCatchallWildcardRegex = "";
    if (routeParts[routeParts.length - 1].match(/^\[\[\.\.\..+\]\]$/)) {
        // If last route part has pattern "[[...xyz]]" we pop the latest route part to get rid of the required trailing
        // slash that would come before it if we didn't pop it.
        routeParts.pop();
        optionalCatchallWildcardRegex = "(?:/(.+?))?";
    }
    var rejoinedRouteParts = routeParts.map(function(routePart) {
        return routePart.replace(/^\[\.\.\..+\]$/, "(.+?)") // Replace catch all wildcard with regex wildcard
        .replace(/^\[.*\]$/, "([^/]+?)");
    }).join("/");
    // eslint-disable-next-line @sentry-internal/sdk/no-regexp-constructor -- routeParts are from the build manifest, so no raw user input
    return new RegExp("^".concat(rejoinedRouteParts).concat(optionalCatchallWildcardRegex, "(?:/)?$"));
}
 //# sourceMappingURL=pagesRouterRoutingInstrumentation.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/routing/nextRoutingInstrumentation.js



/**
 * Instruments the Next.js Client Router.
 *
 * @deprecated Use `browserTracingIntegration()` as exported from `@sentry/nextjs` instead.
 */ function nextRouterInstrumentation(startTransactionCb) {
    var startTransactionOnPageLoad = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, startTransactionOnLocationChange = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, startPageloadSpanCallback = arguments.length > 3 ? arguments[3] : void 0, startNavigationSpanCallback = arguments.length > 4 ? arguments[4] : void 0;
    var isAppRouter = !helpers/* WINDOW.document.getElementById */.m9.document.getElementById("__NEXT_DATA__");
    if (isAppRouter) {
        appRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange, startPageloadSpanCallback || function() {
            return undefined;
        }, startNavigationSpanCallback || function() {
            return undefined;
        });
    } else {
        pagesRouterInstrumentation(startTransactionCb, startTransactionOnPageLoad, startTransactionOnLocationChange, startPageloadSpanCallback || function() {
            return undefined;
        }, startNavigationSpanCallback || function() {
            return undefined;
        });
    }
}
 //# sourceMappingURL=nextRoutingInstrumentation.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/browserTracingIntegration.js








/**
 * A custom BrowserTracing integration for Next.js.
 *
 * @deprecated Use `browserTracingIntegration` instead.
 */ // eslint-disable-next-line deprecation/deprecation
var BrowserTracing = /*#__PURE__*/ function(BrowserTracing$1) {
    "use strict";
    (0,_inherits/* default */.Z)(BrowserTracing, BrowserTracing$1);
    var _super = (0,_create_super/* default */.Z)(BrowserTracing);
    function BrowserTracing(options) {
        (0,_class_call_check/* default */.Z)(this, BrowserTracing);
        return _super.call(this, (0,src_object_spread/* default */.Z)({
            // eslint-disable-next-line deprecation/deprecation
            tracingOrigins:  false ? 0 : (0,_to_consumable_array/* default */.Z)(request/* defaultRequestInstrumentationOptions.tracingOrigins */.k3.tracingOrigins).concat([
                /^(api\/)/
            ]),
            // eslint-disable-next-line deprecation/deprecation
            routingInstrumentation: nextRouterInstrumentation
        }, options));
    }
    return BrowserTracing;
}(browsertracing/* BrowserTracing */.gE);
/**
 * A custom BrowserTracing integration for Next.js.
 */ function browserTracingIntegration_browserTracingIntegration(options) {
    var browserTracingIntegrationInstance = (0,browserTracingIntegration/* browserTracingIntegration */.E8)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({
        // eslint-disable-next-line deprecation/deprecation
        tracingOrigins:  false ? 0 : (0,_to_consumable_array/* default */.Z)(request/* defaultRequestInstrumentationOptions.tracingOrigins */.k3.tracingOrigins).concat([
            /^(api\/)/
        ])
    }, options), {
        instrumentNavigation: false,
        instrumentPageLoad: false
    }));
    var fullOptions = (0,src_object_spread/* default */.Z)((0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, browserTracingIntegrationInstance.options), {
        instrumentPageLoad: true,
        instrumentNavigation: true
    }), options);
    return (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, browserTracingIntegrationInstance), {
        options: fullOptions,
        afterAllSetup: function afterAllSetup(client) {
            var startPageloadCallback = function(startSpanOptions) {
                (0,browserTracingIntegration/* startBrowserTracingPageLoadSpan */.Wo)(client, startSpanOptions);
            };
            var startNavigationCallback = function(startSpanOptions) {
                (0,browserTracingIntegration/* startBrowserTracingNavigationSpan */.og)(client, startSpanOptions);
            };
            // We need to run the navigation span instrumentation before the `afterAllSetup` hook on the normal browser
            // tracing integration because we need to ensure the order of execution is as follows:
            // Instrumentation to start span on RSC fetch request runs -> Instrumentation to put tracing headers from active span on fetch runs
            // If it were the other way around, the RSC fetch request would not receive the tracing headers from the navigation transaction.
            // eslint-disable-next-line deprecation/deprecation
            nextRouterInstrumentation(function() {
                return undefined;
            }, false, fullOptions.instrumentNavigation, startPageloadCallback, startNavigationCallback);
            browserTracingIntegrationInstance.afterAllSetup(client);
            // eslint-disable-next-line deprecation/deprecation
            nextRouterInstrumentation(function() {
                return undefined;
            }, fullOptions.instrumentPageLoad, false, startPageloadCallback, startNavigationCallback);
        }
    });
}
 //# sourceMappingURL=browserTracingIntegration.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_optionalChain.js
var _optionalChain = __webpack_require__(57374);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/integration.js
var integration = __webpack_require__(62909);
// EXTERNAL MODULE: ./node_modules/@sentry/integrations/esm/rewriteframes.js + 1 modules
var rewriteframes = __webpack_require__(6157);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/worldwide.js
var worldwide = __webpack_require__(74672);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/rewriteFramesIntegration.js





var globalWithInjectedValues = worldwide/* GLOBAL_OBJ */.n2;
var customRewriteFramesIntegration = function(options) {
    // This value is injected at build time, based on the output directory specified in the build config. Though a default
    // is set there, we set it here as well, just in case something has gone wrong with the injection.
    var assetPrefixPath = globalWithInjectedValues.__rewriteFramesAssetPrefixPath__ || "";
    return (0,rewriteframes/* rewriteFramesIntegration */.v)((0,src_object_spread/* default */.Z)({
        // Turn `<origin>/<path>/_next/static/...` into `app:///_next/static/...`
        iteratee: function(frame) {
            try {
                var origin = new URL(frame.filename).origin;
                frame.filename = (0,_optionalChain/* _optionalChain */.x)([
                    frame,
                    "access",
                    function(_) {
                        return _.filename;
                    },
                    "optionalAccess",
                    function(_2) {
                        return _2.replace;
                    },
                    "call",
                    function(_3) {
                        return _3(origin, "app://");
                    },
                    "access",
                    function(_4) {
                        return _4.replace;
                    },
                    "call",
                    function(_5) {
                        return _5(assetPrefixPath, "");
                    }
                ]);
            } catch (err) {
            // Filename wasn't a properly formed URL, so there's nothing we can do
            }
            // We need to URI-decode the filename because Next.js has wildcard routes like "/users/[id].js" which show up as "/users/%5id%5.js" in Error stacktraces.
            // The corresponding sources that Next.js generates have proper brackets so we also need proper brackets in the frame so that source map resolving works.
            if (frame.filename && frame.filename.startsWith("app:///_next")) {
                frame.filename = decodeURI(frame.filename);
            }
            if (frame.filename && frame.filename.match(/^app:\/\/\/_next\/static\/chunks\/(main-|main-app-|polyfills-|webpack-|framework-|framework\.)[0-9a-f]+\.js$/)) {
                // We don't care about these frames. It's Next.js internal code.
                frame.in_app = false;
            }
            return frame;
        }
    }, options));
};
var rewriteFramesIntegration = (0,integration/* defineIntegration */._I)(customRewriteFramesIntegration);
 //# sourceMappingURL=rewriteFramesIntegration.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/dsn.js
var dsn = __webpack_require__(74094);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/tunnelRoute.js


var tunnelRoute_globalWithInjectedValues = worldwide/* GLOBAL_OBJ */.n2;
/**
 * Applies the `tunnel` option to the Next.js SDK options based on `withSentryConfig`'s `tunnelRoute` option.
 */ function applyTunnelRouteOption(options) {
    var tunnelRouteOption = tunnelRoute_globalWithInjectedValues.__sentryRewritesTunnelPath__;
    if (tunnelRouteOption && options.dsn) {
        var dsnComponents = (0,dsn/* dsnFromString */.U4)(options.dsn);
        if (!dsnComponents) {
            return;
        }
        var sentrySaasDsnMatch = dsnComponents.host.match(/^o(\d+)\.ingest(?:\.([a-z]{2}))?\.sentry\.io$/);
        if (sentrySaasDsnMatch) {
            var orgId = sentrySaasDsnMatch[1];
            var regionCode = sentrySaasDsnMatch[2];
            var tunnelPath = "".concat(tunnelRouteOption, "?o=").concat(orgId, "&p=").concat(dsnComponents.projectId);
            if (regionCode) {
                tunnelPath += "&r=".concat(regionCode);
            }
            options.tunnel = tunnelPath;
            debug_build/* DEBUG_BUILD */.X && logger/* logger.info */.kg.info('Tunneling events to "'.concat(tunnelPath, '"'));
        } else {
            debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("Provided DSN is not a Sentry SaaS DSN. Will not tunnel events.");
        }
    }
}
 //# sourceMappingURL=tunnelRoute.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/esm/common/_error.js
var _error = __webpack_require__(89020);
// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/hubextensions.js + 1 modules
var hubextensions = __webpack_require__(97576);
// EXTERNAL MODULE: ./node_modules/next/constants.js
var constants = __webpack_require__(31365);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/utils/isBuild.js
/* provided dependency */ var isBuild_process = __webpack_require__(34155);

/**
 * Decide if the currently running process is part of the build phase or happening at runtime.
 */ function isBuild() {
    return isBuild_process.env.NEXT_PHASE === constants.PHASE_PRODUCTION_BUILD;
}
 //# sourceMappingURL=isBuild.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/utils/platformSupportsStreaming.js
/* provided dependency */ var platformSupportsStreaming_process = __webpack_require__(34155);
var platformSupportsStreaming = function() {
    return !platformSupportsStreaming_process.env.LAMBDA_TASK_ROOT && !platformSupportsStreaming_process.env.VERCEL;
};
 //# sourceMappingURL=platformSupportsStreaming.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/nextjs/esm/common/utils/responseEnd.js
var responseEnd = __webpack_require__(84063);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/utils/wrapperUtils.js









/**
 * Grabs a span off a Next.js datafetcher request object, if it was previously put there via
 * `setSpanOnRequest`.
 *
 * @param req The Next.js datafetcher request object
 * @returns the span on the request object if there is one, or `undefined` if the request object didn't have one.
 */ function getSpanFromRequest(req) {
    return req._sentrySpan;
}
function setSpanOnRequest(transaction, req) {
    req._sentrySpan = transaction;
}
/**
 * Wraps a function that potentially throws. If it does, the error is passed to `captureException` and rethrown.
 *
 * Note: This function turns the wrapped function into an asynchronous one.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function withErrorInstrumentation(origFunction) {
    return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _len, origFunctionArguments, _key, e;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    for(_len = _arguments.length, origFunctionArguments = new Array(_len), _key = 0; _key < _len; _key++){
                        origFunctionArguments[_key] = _arguments[_key];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        origFunction.apply(this, origFunctionArguments)
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
                case 3:
                    e = _state.sent();
                    // TODO: Extract error logic from `withSentry` in here or create a new wrapper with said logic or something like that.
                    (0,esm_exports/* captureException */.Tb)(e, {
                        mechanism: {
                            handled: false
                        }
                    });
                    throw e;
                case 4:
                    return [
                        2
                    ];
            }
        });
    });
}
/**
 * Calls a server-side data fetching function (that takes a `req` and `res` object in its context) with tracing
 * instrumentation. A transaction will be created for the incoming request (if it doesn't already exist) in addition to
 * a span for the wrapped data fetching function.
 *
 * All of the above happens in an isolated domain, meaning all thrown errors will be associated with the correct span.
 *
 * @param origDataFetcher The data fetching method to call.
 * @param origFunctionArguments The arguments to call the data fetching method with.
 * @param req The data fetching function's request object.
 * @param res The data fetching function's response object.
 * @param options Options providing details for the created transaction and span.
 * @returns what the data fetching method call returned.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function withTracedServerSideDataFetcher(origDataFetcher, req, res, options) {
    return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _len, args, _key, _this;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = _arguments[_key];
            }
            _this = this;
            return [
                2,
                (0,esm_exports/* withIsolationScope */.wi)(function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(isolationScope) {
                        var sentryTrace, baggage;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            isolationScope.setSDKProcessingMetadata({
                                request: req
                            });
                            sentryTrace = req.headers && (0,is/* isString */.HD)(req.headers["sentry-trace"]) ? req.headers["sentry-trace"] : undefined;
                            baggage = (0,_optionalChain/* _optionalChain */.x)([
                                req,
                                "access",
                                function(_) {
                                    return _.headers;
                                },
                                "optionalAccess",
                                function(_2) {
                                    return _2.baggage;
                                }
                            ]);
                            return [
                                2,
                                (0,trace/* continueTrace */.yn)({
                                    sentryTrace: sentryTrace,
                                    baggage: baggage
                                }, function() {
                                    var requestSpan = getSpanFromRequest(req);
                                    if (!requestSpan) {
                                        var _obj;
                                        // TODO(v8): Simplify these checks when startInactiveSpan always returns a span
                                        requestSpan = (0,trace/* startInactiveSpan */.qp)({
                                            name: options.requestedRouteName,
                                            op: "http.server",
                                            attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.function.nextjs"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, "route"), _obj)
                                        });
                                        if (requestSpan) {
                                            requestSpan.setStatus("ok");
                                            setSpanOnRequest(requestSpan, req);
                                            (0,responseEnd/* autoEndSpanOnResponseEnd */.RR)(requestSpan, res);
                                        }
                                    }
                                    var withActiveSpanCallback = function() {
                                        var _obj;
                                        return (0,trace/* startSpanManual */.V0)({
                                            op: "function.nextjs",
                                            name: "".concat(options.dataFetchingMethodName, " (").concat(options.dataFetcherRouteName, ")"),
                                            attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.function.nextjs"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, "route"), _obj)
                                        }, function() {
                                            var _ref = (0,_async_to_generator/* default */.Z)(function(dataFetcherSpan) {
                                                var e;
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            (0,_optionalChain/* _optionalChain */.x)([
                                                                dataFetcherSpan,
                                                                "optionalAccess",
                                                                function(_3) {
                                                                    return _3.setStatus;
                                                                },
                                                                "call",
                                                                function(_4) {
                                                                    return _4("ok");
                                                                }
                                                            ]);
                                                            _state.label = 1;
                                                        case 1:
                                                            _state.trys.push([
                                                                1,
                                                                3,
                                                                4,
                                                                7
                                                            ]);
                                                            return [
                                                                4,
                                                                origDataFetcher.apply(_this, args)
                                                            ];
                                                        case 2:
                                                            return [
                                                                2,
                                                                _state.sent()
                                                            ];
                                                        case 3:
                                                            e = _state.sent();
                                                            (0,_optionalChain/* _optionalChain */.x)([
                                                                dataFetcherSpan,
                                                                "optionalAccess",
                                                                function(_5) {
                                                                    return _5.setStatus;
                                                                },
                                                                "call",
                                                                function(_6) {
                                                                    return _6("internal_error");
                                                                }
                                                            ]);
                                                            (0,_optionalChain/* _optionalChain */.x)([
                                                                requestSpan,
                                                                "optionalAccess",
                                                                function(_7) {
                                                                    return _7.setStatus;
                                                                },
                                                                "call",
                                                                function(_8) {
                                                                    return _8("internal_error");
                                                                }
                                                            ]);
                                                            throw e;
                                                        case 4:
                                                            (0,_optionalChain/* _optionalChain */.x)([
                                                                dataFetcherSpan,
                                                                "optionalAccess",
                                                                function(_9) {
                                                                    return _9.end;
                                                                },
                                                                "call",
                                                                function(_10) {
                                                                    return _10();
                                                                }
                                                            ]);
                                                            if (!!platformSupportsStreaming()) return [
                                                                3,
                                                                6
                                                            ];
                                                            return [
                                                                4,
                                                                (0,responseEnd/* flushQueue */.DO)()
                                                            ];
                                                        case 5:
                                                            _state.sent();
                                                            _state.label = 6;
                                                        case 6:
                                                            return [
                                                                7
                                                            ];
                                                        case 7:
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            });
                                            return function(dataFetcherSpan) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }());
                                    };
                                    if (requestSpan) {
                                        return (0,esm_exports/* withActiveSpan */._d)(requestSpan, withActiveSpanCallback);
                                    } else {
                                        return withActiveSpanCallback();
                                    }
                                })
                            ];
                        });
                    });
                    return function(isolationScope) {
                        return _ref.apply(this, arguments);
                    };
                }())
            ];
        });
    });
}
function callDataFetcherTraced(origFunction, origFunctionArgs, options) {
    return _callDataFetcherTraced.apply(this, arguments);
}
function _callDataFetcherTraced() {
    _callDataFetcherTraced = /**
 * Call a data fetcher and trace it. Only traces the function if there is an active transaction on the scope.
 *
 * We only do the following until we move transaction creation into this function: When called, the wrapped function
 * will also update the name of the active transaction with a parameterized route provided via the `options` argument.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0,_async_to_generator/* default */.Z)(function(origFunction, origFunctionArgs, options) {
        var parameterizedRoute, dataFetchingMethodName, _obj;
        return (0,tslib_es6.__generator)(this, function(_state) {
            parameterizedRoute = options.parameterizedRoute, dataFetchingMethodName = options.dataFetchingMethodName;
            return [
                2,
                (0,trace/* startSpan */.GK)({
                    op: "function.nextjs",
                    name: "".concat(dataFetchingMethodName, " (").concat(parameterizedRoute, ")"),
                    attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.function.nextjs"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, "route"), _obj)
                }, function() {
                    var _ref = (0,_async_to_generator/* default */.Z)(function(dataFetcherSpan) {
                        var e;
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    (0,_optionalChain/* _optionalChain */.x)([
                                        dataFetcherSpan,
                                        "optionalAccess",
                                        function(_11) {
                                            return _11.setStatus;
                                        },
                                        "call",
                                        function(_12) {
                                            return _12("ok");
                                        }
                                    ]);
                                    _state.label = 1;
                                case 1:
                                    _state.trys.push([
                                        1,
                                        3,
                                        4,
                                        7
                                    ]);
                                    return [
                                        4,
                                        origFunction.apply(void 0, (0,_to_consumable_array/* default */.Z)(origFunctionArgs))
                                    ];
                                case 2:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 3:
                                    e = _state.sent();
                                    (0,_optionalChain/* _optionalChain */.x)([
                                        dataFetcherSpan,
                                        "optionalAccess",
                                        function(_13) {
                                            return _13.setStatus;
                                        },
                                        "call",
                                        function(_14) {
                                            return _14("internal_error");
                                        }
                                    ]);
                                    (0,esm_exports/* captureException */.Tb)(e, {
                                        mechanism: {
                                            handled: false
                                        }
                                    });
                                    throw e;
                                case 4:
                                    (0,_optionalChain/* _optionalChain */.x)([
                                        dataFetcherSpan,
                                        "optionalAccess",
                                        function(_15) {
                                            return _15.end;
                                        },
                                        "call",
                                        function(_16) {
                                            return _16();
                                        }
                                    ]);
                                    if (!!platformSupportsStreaming()) return [
                                        3,
                                        6
                                    ];
                                    return [
                                        4,
                                        (0,responseEnd/* flushQueue */.DO)()
                                    ];
                                case 5:
                                    _state.sent();
                                    _state.label = 6;
                                case 6:
                                    return [
                                        7
                                    ];
                                case 7:
                                    return [
                                        2
                                    ];
                            }
                        });
                    });
                    return function(dataFetcherSpan) {
                        return _ref.apply(this, arguments);
                    };
                }())
            ];
        });
    });
    return _callDataFetcherTraced.apply(this, arguments);
}
 //# sourceMappingURL=wrapperUtils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapGetStaticPropsWithSentry.js




/**
 * Create a wrapped version of the user's exported `getStaticProps` function
 *
 * @param origGetStaticProps The user's `getStaticProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */ function wrapGetStaticPropsWithSentry(origGetStaticPropsa, parameterizedRoute) {
    return new Proxy(origGetStaticPropsa, {
        apply: function(wrappingTarget, thisArg, args) {
            if (isBuild()) {
                return wrappingTarget.apply(thisArg, args);
            }
            (0,hubextensions/* addTracingExtensions */.T)();
            var errorWrappedGetStaticProps = withErrorInstrumentation(wrappingTarget);
            var options = (0,_optionalChain/* _optionalChain */.x)([
                esm_exports/* getClient */.s3,
                "call",
                function(_) {
                    return _();
                },
                "optionalAccess",
                function(_2) {
                    return _2.getOptions;
                },
                "call",
                function(_3) {
                    return _3();
                }
            ]);
            if ((0,_optionalChain/* _optionalChain */.x)([
                options,
                "optionalAccess",
                function(_4) {
                    return _4.instrumenter;
                }
            ]) === "sentry") {
                return callDataFetcherTraced(errorWrappedGetStaticProps, args, {
                    parameterizedRoute: parameterizedRoute,
                    dataFetchingMethodName: "getStaticProps"
                });
            }
            return errorWrappedGetStaticProps.apply(thisArg, args);
        }
    });
}
/**
 * @deprecated Use `wrapGetStaticPropsWithSentry` instead.
 */ var withSentryGetStaticProps = wrapGetStaticPropsWithSentry;
 //# sourceMappingURL=wrapGetStaticPropsWithSentry.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_nullishCoalesce.js
var _nullishCoalesce = __webpack_require__(42712);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/buildPolyfills/_asyncNullishCoalesce.js



function _asyncNullishCoalesce(lhs, rhsFn) {
    return __asyncNullishCoalesce.apply(this, arguments);
}
function __asyncNullishCoalesce() {
    __asyncNullishCoalesce = // https://github.com/alangpierce/sucrase/tree/265887868966917f3b924ce38dfad01fbab1329f
    /**
 * Polyfill for the nullish coalescing operator (`??`), when used in situations where at least one of the values is the
 * result of an async operation.
 *
 * Note that the RHS is wrapped in a function so that if it's a computed value, that evaluation won't happen unless the
 * LHS evaluates to a nullish value, to mimic the operator's short-circuiting behavior.
 *
 * Adapted from Sucrase (https://github.com/alangpierce/sucrase)
 *
 * @param lhs The value of the expression to the left of the `??`
 * @param rhsFn A function returning the value of the expression to the right of the `??`
 * @returns The LHS value, unless it's `null` or `undefined`, in which case, the RHS value
 */ (0,_async_to_generator/* default */.Z)(function(lhs, rhsFn) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,_nullishCoalesce/* _nullishCoalesce */.h)(lhs, rhsFn)
            ];
        });
    });
    return __asyncNullishCoalesce.apply(this, arguments);
}
// Sucrase version:
// async function _asyncNullishCoalesce(lhs, rhsFn) {
//   if (lhs != null) {
//     return lhs;
//   } else {
//     return await rhsFn();
//   }
// }
 //# sourceMappingURL=_asyncNullishCoalesce.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/dynamicSamplingContext.js
var tracing_dynamicSamplingContext = __webpack_require__(63055);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/baggage.js
var baggage = __webpack_require__(50257);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapGetInitialPropsWithSentry.js








/**
 * Create a wrapped version of the user's exported `getInitialProps` function
 *
 * @param origGetInitialProps The user's `getInitialProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */ function wrapGetInitialPropsWithSentry(origGetInitialProps) {
    return new Proxy(origGetInitialProps, {
        apply: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(wrappingTarget, thisArg, args) {
                var _args, context, req, res, errorWrappedGetInitialProps, options, tracedGetInitialProps, initialProps, activeSpan, requestSpan, dynamicSamplingContext;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (isBuild()) {
                                return [
                                    2,
                                    wrappingTarget.apply(thisArg, args)
                                ];
                            }
                            (0,hubextensions/* addTracingExtensions */.T)();
                            _args = (0,src_sliced_to_array/* default */.Z)(args, 1), context = _args[0];
                            req = context.req, res = context.res;
                            errorWrappedGetInitialProps = withErrorInstrumentation(wrappingTarget);
                            options = (0,_optionalChain/* _optionalChain */.x)([
                                esm_exports/* getClient */.s3,
                                "call",
                                function(_) {
                                    return _();
                                },
                                "optionalAccess",
                                function(_2) {
                                    return _2.getOptions;
                                },
                                "call",
                                function(_3) {
                                    return _3();
                                }
                            ]);
                            if (!(req && res && (0,_optionalChain/* _optionalChain */.x)([
                                options,
                                "optionalAccess",
                                function(_4) {
                                    return _4.instrumenter;
                                }
                            ]) === "sentry")) return [
                                3,
                                3
                            ];
                            tracedGetInitialProps = withTracedServerSideDataFetcher(errorWrappedGetInitialProps, req, res, {
                                dataFetcherRouteName: context.pathname,
                                requestedRouteName: context.pathname,
                                dataFetchingMethodName: "getInitialProps"
                            });
                            return [
                                4,
                                tracedGetInitialProps.apply(thisArg, args)
                            ];
                        case 1:
                            return [
                                4,
                                _asyncNullishCoalesce.apply(void 0, [
                                    _state.sent(),
                                    /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                            return [
                                                2,
                                                {}
                                            ];
                                        });
                                    })
                                ])
                            ];
                        case 2:
                            initialProps = _state.sent();
                            activeSpan = (0,trace/* getActiveSpan */.HN)();
                            requestSpan = (0,_nullishCoalesce/* _nullishCoalesce */.h)(getSpanFromRequest(req), function() {
                                return activeSpan ? (0,getRootSpan/* getRootSpan */.G)(activeSpan) : undefined;
                            });
                            if (requestSpan) {
                                initialProps._sentryTraceData = (0,spanUtils/* spanToTraceHeader */.Hb)(requestSpan);
                                dynamicSamplingContext = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(requestSpan);
                                initialProps._sentryBaggage = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dynamicSamplingContext);
                            }
                            return [
                                2,
                                initialProps
                            ];
                        case 3:
                            return [
                                2,
                                errorWrappedGetInitialProps.apply(thisArg, args)
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(wrappingTarget, thisArg, args) {
                return _ref.apply(this, arguments);
            };
        }()
    });
}
/**
 * @deprecated Use `wrapGetInitialPropsWithSentry` instead.
 */ var withSentryServerSideGetInitialProps = wrapGetInitialPropsWithSentry;
 //# sourceMappingURL=wrapGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapAppGetInitialPropsWithSentry.js








/**
 * Create a wrapped version of the user's exported `getInitialProps` function in
 * a custom app ("_app.js").
 *
 * @param origAppGetInitialProps The user's `getInitialProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */ function wrapAppGetInitialPropsWithSentry(origAppGetInitialProps) {
    return new Proxy(origAppGetInitialProps, {
        apply: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(wrappingTarget, thisArg, args) {
                var _args, context, _ctx, req, res, errorWrappedAppGetInitialProps, options, tracedGetInitialProps, appGetInitialProps, activeSpan, requestSpan, dynamicSamplingContext;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (isBuild()) {
                                return [
                                    2,
                                    wrappingTarget.apply(thisArg, args)
                                ];
                            }
                            (0,hubextensions/* addTracingExtensions */.T)();
                            _args = (0,src_sliced_to_array/* default */.Z)(args, 1), context = _args[0];
                            _ctx = context.ctx, req = _ctx.req, res = _ctx.res;
                            errorWrappedAppGetInitialProps = withErrorInstrumentation(wrappingTarget);
                            options = (0,_optionalChain/* _optionalChain */.x)([
                                esm_exports/* getClient */.s3,
                                "call",
                                function(_) {
                                    return _();
                                },
                                "optionalAccess",
                                function(_2) {
                                    return _2.getOptions;
                                },
                                "call",
                                function(_3) {
                                    return _3();
                                }
                            ]);
                            if (!(req && res && (0,_optionalChain/* _optionalChain */.x)([
                                options,
                                "optionalAccess",
                                function(_4) {
                                    return _4.instrumenter;
                                }
                            ]) === "sentry")) return [
                                3,
                                2
                            ];
                            tracedGetInitialProps = withTracedServerSideDataFetcher(errorWrappedAppGetInitialProps, req, res, {
                                dataFetcherRouteName: "/_app",
                                requestedRouteName: context.ctx.pathname,
                                dataFetchingMethodName: "getInitialProps"
                            });
                            return [
                                4,
                                tracedGetInitialProps.apply(thisArg, args)
                            ];
                        case 1:
                            appGetInitialProps = _state.sent();
                            activeSpan = (0,trace/* getActiveSpan */.HN)();
                            requestSpan = (0,_nullishCoalesce/* _nullishCoalesce */.h)(getSpanFromRequest(req), function() {
                                return activeSpan ? (0,getRootSpan/* getRootSpan */.G)(activeSpan) : undefined;
                            });
                            // Per definition, `pageProps` is not optional, however an increased amount of users doesn't seem to call
                            // `App.getInitialProps(appContext)` in their custom `_app` pages which is required as per
                            // https://nextjs.org/docs/advanced-features/custom-app - resulting in missing `pageProps`.
                            // For this reason, we just handle the case where `pageProps` doesn't exist explicitly.
                            if (!appGetInitialProps.pageProps) {
                                appGetInitialProps.pageProps = {};
                            }
                            if (requestSpan) {
                                appGetInitialProps.pageProps._sentryTraceData = (0,spanUtils/* spanToTraceHeader */.Hb)(requestSpan);
                                dynamicSamplingContext = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(requestSpan);
                                appGetInitialProps.pageProps._sentryBaggage = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dynamicSamplingContext);
                            }
                            return [
                                2,
                                appGetInitialProps
                            ];
                        case 2:
                            return [
                                2,
                                errorWrappedAppGetInitialProps.apply(thisArg, args)
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(wrappingTarget, thisArg, args) {
                return _ref.apply(this, arguments);
            };
        }()
    });
}
/**
 * @deprecated Use `wrapAppGetInitialPropsWithSentry` instead.
 */ var withSentryServerSideAppGetInitialProps = wrapAppGetInitialPropsWithSentry;
 //# sourceMappingURL=wrapAppGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapDocumentGetInitialPropsWithSentry.js





/**
 * Create a wrapped version of the user's exported `getInitialProps` function in
 * a custom document ("_document.js").
 *
 * @param origDocumentGetInitialProps The user's `getInitialProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */ function wrapDocumentGetInitialPropsWithSentry(origDocumentGetInitialProps) {
    return new Proxy(origDocumentGetInitialProps, {
        apply: function(wrappingTarget, thisArg, args) {
            if (isBuild()) {
                return wrappingTarget.apply(thisArg, args);
            }
            (0,hubextensions/* addTracingExtensions */.T)();
            var _args = (0,src_sliced_to_array/* default */.Z)(args, 1), context = _args[0];
            var req = context.req, res = context.res;
            var errorWrappedGetInitialProps = withErrorInstrumentation(wrappingTarget);
            var options = (0,_optionalChain/* _optionalChain */.x)([
                esm_exports/* getClient */.s3,
                "call",
                function(_) {
                    return _();
                },
                "optionalAccess",
                function(_2) {
                    return _2.getOptions;
                },
                "call",
                function(_3) {
                    return _3();
                }
            ]);
            // Generally we can assume that `req` and `res` are always defined on the server:
            // https://nextjs.org/docs/api-reference/data-fetching/get-initial-props#context-object
            // This does not seem to be the case in dev mode. Because we have no clean way of associating the the data fetcher
            // span with each other when there are no req or res objects, we simply do not trace them at all here.
            if (req && res && (0,_optionalChain/* _optionalChain */.x)([
                options,
                "optionalAccess",
                function(_4) {
                    return _4.instrumenter;
                }
            ]) === "sentry") {
                var tracedGetInitialProps = withTracedServerSideDataFetcher(errorWrappedGetInitialProps, req, res, {
                    dataFetcherRouteName: "/_document",
                    requestedRouteName: context.pathname,
                    dataFetchingMethodName: "getInitialProps"
                });
                return tracedGetInitialProps.apply(thisArg, args);
            } else {
                return errorWrappedGetInitialProps.apply(thisArg, args);
            }
        }
    });
}
/**
 * @deprecated Use `wrapDocumentGetInitialPropsWithSentry` instead.
 */ var withSentryServerSideDocumentGetInitialProps = wrapDocumentGetInitialPropsWithSentry;
 //# sourceMappingURL=wrapDocumentGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapErrorGetInitialPropsWithSentry.js








/**
 * Create a wrapped version of the user's exported `getInitialProps` function in
 * a custom error page ("_error.js").
 *
 * @param origErrorGetInitialProps The user's `getInitialProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */ function wrapErrorGetInitialPropsWithSentry(origErrorGetInitialProps) {
    return new Proxy(origErrorGetInitialProps, {
        apply: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(wrappingTarget, thisArg, args) {
                var _args, context, req, res, errorWrappedGetInitialProps, options, tracedGetInitialProps, errorGetInitialProps, activeSpan, requestSpan, dynamicSamplingContext;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (isBuild()) {
                                return [
                                    2,
                                    wrappingTarget.apply(thisArg, args)
                                ];
                            }
                            (0,hubextensions/* addTracingExtensions */.T)();
                            _args = (0,src_sliced_to_array/* default */.Z)(args, 1), context = _args[0];
                            req = context.req, res = context.res;
                            errorWrappedGetInitialProps = withErrorInstrumentation(wrappingTarget);
                            options = (0,_optionalChain/* _optionalChain */.x)([
                                esm_exports/* getClient */.s3,
                                "call",
                                function(_) {
                                    return _();
                                },
                                "optionalAccess",
                                function(_2) {
                                    return _2.getOptions;
                                },
                                "call",
                                function(_3) {
                                    return _3();
                                }
                            ]);
                            if (!(req && res && (0,_optionalChain/* _optionalChain */.x)([
                                options,
                                "optionalAccess",
                                function(_4) {
                                    return _4.instrumenter;
                                }
                            ]) === "sentry")) return [
                                3,
                                2
                            ];
                            tracedGetInitialProps = withTracedServerSideDataFetcher(errorWrappedGetInitialProps, req, res, {
                                dataFetcherRouteName: "/_error",
                                requestedRouteName: context.pathname,
                                dataFetchingMethodName: "getInitialProps"
                            });
                            return [
                                4,
                                tracedGetInitialProps.apply(thisArg, args)
                            ];
                        case 1:
                            errorGetInitialProps = _state.sent();
                            activeSpan = (0,trace/* getActiveSpan */.HN)();
                            requestSpan = (0,_nullishCoalesce/* _nullishCoalesce */.h)(getSpanFromRequest(req), function() {
                                return activeSpan ? (0,getRootSpan/* getRootSpan */.G)(activeSpan) : undefined;
                            });
                            if (requestSpan) {
                                errorGetInitialProps._sentryTraceData = (0,spanUtils/* spanToTraceHeader */.Hb)(requestSpan);
                                dynamicSamplingContext = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(requestSpan);
                                errorGetInitialProps._sentryBaggage = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dynamicSamplingContext);
                            }
                            return [
                                2,
                                errorGetInitialProps
                            ];
                        case 2:
                            return [
                                2,
                                errorWrappedGetInitialProps.apply(thisArg, args)
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(wrappingTarget, thisArg, args) {
                return _ref.apply(this, arguments);
            };
        }()
    });
}
/**
 * @deprecated Use `wrapErrorGetInitialPropsWithSentry` instead.
 */ var withSentryServerSideErrorGetInitialProps = wrapErrorGetInitialPropsWithSentry;
 //# sourceMappingURL=wrapErrorGetInitialPropsWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapGetServerSidePropsWithSentry.js








/**
 * Create a wrapped version of the user's exported `getServerSideProps` function
 *
 * @param origGetServerSideProps The user's `getServerSideProps` function
 * @param parameterizedRoute The page's parameterized route
 * @returns A wrapped version of the function
 */ function wrapGetServerSidePropsWithSentry(origGetServerSideProps, parameterizedRoute) {
    return new Proxy(origGetServerSideProps, {
        apply: function() {
            var _ref = (0,_async_to_generator/* default */.Z)(function(wrappingTarget, thisArg, args) {
                var _args, context, req, res, errorWrappedGetServerSideProps, options, tracedGetServerSideProps, serverSideProps, activeSpan, requestTransaction, dynamicSamplingContext;
                return (0,tslib_es6.__generator)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            if (isBuild()) {
                                return [
                                    2,
                                    wrappingTarget.apply(thisArg, args)
                                ];
                            }
                            (0,hubextensions/* addTracingExtensions */.T)();
                            _args = (0,src_sliced_to_array/* default */.Z)(args, 1), context = _args[0];
                            req = context.req, res = context.res;
                            errorWrappedGetServerSideProps = withErrorInstrumentation(wrappingTarget);
                            options = (0,_optionalChain/* _optionalChain */.x)([
                                esm_exports/* getClient */.s3,
                                "call",
                                function(_) {
                                    return _();
                                },
                                "optionalAccess",
                                function(_2) {
                                    return _2.getOptions;
                                },
                                "call",
                                function(_3) {
                                    return _3();
                                }
                            ]);
                            if (!((0,_optionalChain/* _optionalChain */.x)([
                                options,
                                "optionalAccess",
                                function(_4) {
                                    return _4.instrumenter;
                                }
                            ]) === "sentry")) return [
                                3,
                                2
                            ];
                            tracedGetServerSideProps = withTracedServerSideDataFetcher(errorWrappedGetServerSideProps, req, res, {
                                dataFetcherRouteName: parameterizedRoute,
                                requestedRouteName: parameterizedRoute,
                                dataFetchingMethodName: "getServerSideProps"
                            });
                            return [
                                4,
                                tracedGetServerSideProps.apply(thisArg, args)
                            ];
                        case 1:
                            serverSideProps = _state.sent();
                            if (serverSideProps && "props" in serverSideProps) {
                                activeSpan = (0,trace/* getActiveSpan */.HN)();
                                requestTransaction = (0,_nullishCoalesce/* _nullishCoalesce */.h)(getSpanFromRequest(req), function() {
                                    return activeSpan ? (0,getRootSpan/* getRootSpan */.G)(activeSpan) : undefined;
                                });
                                if (requestTransaction) {
                                    serverSideProps.props._sentryTraceData = (0,spanUtils/* spanToTraceHeader */.Hb)(requestTransaction);
                                    dynamicSamplingContext = (0,tracing_dynamicSamplingContext/* getDynamicSamplingContextFromSpan */.j)(requestTransaction);
                                    serverSideProps.props._sentryBaggage = (0,baggage/* dynamicSamplingContextToSentryBaggageHeader */.IQ)(dynamicSamplingContext);
                                }
                            }
                            return [
                                2,
                                serverSideProps
                            ];
                        case 2:
                            return [
                                2,
                                errorWrappedGetServerSideProps.apply(thisArg, args)
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            });
            return function(wrappingTarget, thisArg, args) {
                return _ref.apply(this, arguments);
            };
        }()
    });
}
/**
 * @deprecated Use `withSentryGetServerSideProps` instead.
 */ var withSentryGetServerSideProps = wrapGetServerSidePropsWithSentry;
 //# sourceMappingURL=wrapGetServerSidePropsWithSentry.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/utils/handleCallbackErrors.js
var handleCallbackErrors = __webpack_require__(15968);
// EXTERNAL MODULE: ./node_modules/@sentry/utils/esm/debug-build.js
var esm_debug_build = __webpack_require__(35614);
;// CONCATENATED MODULE: ./node_modules/@sentry/utils/esm/requestdata.js









var DEFAULT_INCLUDES = {
    ip: false,
    request: true,
    transaction: true,
    user: true
};
var DEFAULT_REQUEST_INCLUDES = (/* unused pure expression or super */ null && ([
    "cookies",
    "data",
    "headers",
    "method",
    "query_string",
    "url"
]));
var DEFAULT_USER_INCLUDES = (/* unused pure expression or super */ null && ([
    "id",
    "username",
    "email"
]));
/**
 * Sets parameterized route as transaction name e.g.: `GET /users/:id`
 * Also adds more context data on the transaction from the request.
 *
 * @deprecated This utility will be removed in v8.
 */ function addRequestDataToTransaction(transaction, req, deps) {
    if (!transaction) return;
    // eslint-disable-next-line deprecation/deprecation
    if (!transaction.metadata.source || transaction.metadata.source === "url") {
        // Attempt to grab a parameterized route off of the request
        var ref = _sliced_to_array(extractPathForTransaction(req, {
            path: true,
            method: true
        }), 2), name = ref[0], source = ref[1];
        transaction.updateName(name);
        // TODO: SEMANTIC_ATTRIBUTE_SENTRY_SOURCE is in core, align this once we merge utils & core
        // eslint-disable-next-line deprecation/deprecation
        transaction.setMetadata({
            source: source
        });
    }
    transaction.setAttribute("url", req.originalUrl || req.url);
    if (req.baseUrl) {
        transaction.setAttribute("baseUrl", req.baseUrl);
    }
    // TODO: We need to rewrite this to a flat format?
    // eslint-disable-next-line deprecation/deprecation
    transaction.setData("query", extractQueryParams(req, deps));
}
/**
 * Extracts a complete and parameterized path from the request object and uses it to construct transaction name.
 * If the parameterized transaction name cannot be extracted, we fall back to the raw URL.
 *
 * Additionally, this function determines and returns the transaction name source
 *
 * eg. GET /mountpoint/user/:id
 *
 * @param req A request object
 * @param options What to include in the transaction name (method, path, or a custom route name to be
 *                used instead of the request's route)
 *
 * @returns A tuple of the fully constructed transaction name [0] and its source [1] (can be either 'route' or 'url')
 */ function extractPathForTransaction(req) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var method = req.method && req.method.toUpperCase();
    var path = "";
    var source = "url";
    // Check to see if there's a parameterized route we can use (as there is in Express)
    if (options.customRoute || req.route) {
        path = options.customRoute || "".concat(req.baseUrl || "").concat(req.route && req.route.path);
        source = "route";
    } else if (req.originalUrl || req.url) {
        path = stripUrlQueryAndFragment(req.originalUrl || req.url || "");
    }
    var name = "";
    if (options.method && method) {
        name += method;
    }
    if (options.method && options.path) {
        name += " ";
    }
    if (options.path && path) {
        name += path;
    }
    return [
        name,
        source
    ];
}
/** JSDoc */ function extractTransaction(req, type) {
    switch(type){
        case "path":
            {
                return extractPathForTransaction(req, {
                    path: true
                })[0];
            }
        case "handler":
            {
                return req.route && req.route.stack && req.route.stack[0] && req.route.stack[0].name || "<anonymous>";
            }
        case "methodPath":
        default:
            {
                // if exist _reconstructedRoute return that path instead of route.path
                var customRoute = req._reconstructedRoute ? req._reconstructedRoute : undefined;
                return extractPathForTransaction(req, {
                    path: true,
                    method: true,
                    customRoute: customRoute
                })[0];
            }
    }
}
/** JSDoc */ function extractUserData(user, keys) {
    var extractedUser = {};
    var attributes = Array.isArray(keys) ? keys : DEFAULT_USER_INCLUDES;
    attributes.forEach(function(key) {
        if (user && key in user) {
            extractedUser[key] = user[key];
        }
    });
    return extractedUser;
}
/**
 * Normalize data from the request object, accounting for framework differences.
 *
 * @param req The request object from which to extract data
 * @param options.include An optional array of keys to include in the normalized data. Defaults to
 * DEFAULT_REQUEST_INCLUDES if not provided.
 * @param options.deps Injected, platform-specific dependencies
 * @returns An object containing normalized request data
 */ function extractRequestData(req, options) {
    var ref = options || {}, _include = ref.include, include = _include === void 0 ? DEFAULT_REQUEST_INCLUDES : _include, deps = ref.deps;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var requestData = {};
    // headers:
    //   node, express, koa, nextjs: req.headers
    var headers = req.headers || {};
    // method:
    //   node, express, koa, nextjs: req.method
    var method = req.method;
    // host:
    //   express: req.hostname in > 4 and req.host in < 4
    //   koa: req.host
    //   node, nextjs: req.headers.host
    // Express 4 mistakenly strips off port number from req.host / req.hostname so we can't rely on them
    // See: https://github.com/expressjs/express/issues/3047#issuecomment-236653223
    // Also: https://github.com/getsentry/sentry-javascript/issues/1917
    var host = headers.host || req.hostname || req.host || "<no host>";
    // protocol:
    //   node, nextjs: <n/a>
    //   express, koa: req.protocol
    var protocol = req.protocol === "https" || req.socket && req.socket.encrypted ? "https" : "http";
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    var originalUrl = req.originalUrl || req.url || "";
    // absolute url
    var absoluteUrl = originalUrl.startsWith(protocol) ? originalUrl : "".concat(protocol, "://").concat(host).concat(originalUrl);
    include.forEach(function(key) {
        switch(key){
            case "headers":
                {
                    requestData.headers = headers;
                    // Remove the Cookie header in case cookie data should not be included in the event
                    if (!include.includes("cookies")) {
                        delete requestData.headers.cookie;
                    }
                    break;
                }
            case "method":
                {
                    requestData.method = method;
                    break;
                }
            case "url":
                {
                    requestData.url = absoluteUrl;
                    break;
                }
            case "cookies":
                {
                    // cookies:
                    //   node, express, koa: req.headers.cookie
                    //   vercel, sails.js, express (w/ cookie middleware), nextjs: req.cookies
                    requestData.cookies = // TODO (v8 / #5257): We're only sending the empty object for backwards compatibility, so the last bit can
                    // come off in v8
                    req.cookies || headers.cookie && parseCookie(headers.cookie) || {};
                    break;
                }
            case "query_string":
                {
                    // query string:
                    //   node: req.url (raw)
                    //   express, koa, nextjs: req.query
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                    requestData.query_string = extractQueryParams(req, deps);
                    break;
                }
            case "data":
                {
                    if (method === "GET" || method === "HEAD") {
                        break;
                    }
                    // body data:
                    //   express, koa, nextjs: req.body
                    //
                    //   when using node by itself, you have to read the incoming stream(see
                    //   https://nodejs.dev/learn/get-http-request-body-data-using-nodejs); if a user is doing that, we can't know
                    //   where they're going to store the final result, so they'll have to capture this data themselves
                    if (req.body !== undefined) {
                        requestData.data = isString(req.body) ? req.body : JSON.stringify(normalize(req.body));
                    }
                    break;
                }
            default:
                {
                    if (({}).hasOwnProperty.call(req, key)) {
                        requestData[key] = req[key];
                    }
                }
        }
    });
    return requestData;
}
/**
 * Add data from the given request to the given event
 *
 * @param event The event to which the request data will be added
 * @param req Request object
 * @param options.include Flags to control what data is included
 * @param options.deps Injected platform-specific dependencies
 * @returns The mutated `Event` object
 */ function addRequestDataToEvent(event, req, options) {
    var include = _object_spread({}, DEFAULT_INCLUDES, options && options.include);
    if (include.request) {
        var extractedRequestData = Array.isArray(include.request) ? extractRequestData(req, {
            include: include.request,
            deps: options && options.deps
        }) : extractRequestData(req, {
            deps: options && options.deps
        });
        event.request = _object_spread({}, event.request, extractedRequestData);
    }
    if (include.user) {
        var extractedUser = req.user && isPlainObject(req.user) ? extractUserData(req.user, include.user) : {};
        if (Object.keys(extractedUser).length) {
            event.user = _object_spread({}, event.user, extractedUser);
        }
    }
    // client ip:
    //   node, nextjs: req.socket.remoteAddress
    //   express, koa: req.ip
    if (include.ip) {
        var ip = req.ip || req.socket && req.socket.remoteAddress;
        if (ip) {
            event.user = _object_spread_props(_object_spread({}, event.user), {
                ip_address: ip
            });
        }
    }
    if (include.transaction && !event.transaction) {
        // TODO do we even need this anymore?
        // TODO make this work for nextjs
        event.transaction = extractTransaction(req, include.transaction);
    }
    return event;
}
function extractQueryParams(req, deps) {
    // url (including path and query string):
    //   node, express: req.originalUrl
    //   koa, nextjs: req.url
    var originalUrl = req.originalUrl || req.url || "";
    if (!originalUrl) {
        return;
    }
    // The `URL` constructor can't handle internal URLs of the form `/some/path/here`, so stick a dummy protocol and
    // hostname on the beginning. Since the point here is just to grab the query string, it doesn't matter what we use.
    if (originalUrl.startsWith("/")) {
        originalUrl = "http://dogs.are.great".concat(originalUrl);
    }
    try {
        return req.query || typeof URL !== "undefined" && new URL(originalUrl).search.slice(1) || // In Node 8, `URL` isn't in the global scope, so we have to use the built-in module from Node
        deps && deps.url && deps.url.parse(originalUrl).query || undefined;
    } catch (e2) {
        return undefined;
    }
}
/**
 * Transforms a `Headers` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into a simple key-value dict.
 * The header keys will be lower case: e.g. A "Content-Type" header will be stored as "content-type".
 */ // TODO(v8): Make this function return undefined when the extraction fails.
function winterCGHeadersToDict(winterCGHeaders) {
    var headers = {};
    try {
        winterCGHeaders.forEach(function(value, key) {
            if (typeof value === "string") {
                // We check that value is a string even though it might be redundant to make sure prototype pollution is not possible.
                headers[key] = value;
            }
        });
    } catch (e) {
        esm_debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("Sentry failed extracting headers from a request object. If you see this, please file an issue.");
    }
    return headers;
}
/**
 * Converts a `Request` object that implements the `Web Fetch API` (https://developer.mozilla.org/en-US/docs/Web/API/Headers) into the format that the `RequestData` integration understands.
 */ function winterCGRequestToRequestData(req) {
    var headers = winterCGHeadersToDict(req.headers);
    return {
        method: req.method,
        url: req.url,
        headers: headers
    };
}
 //# sourceMappingURL=requestdata.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/nextNavigationErrorUtils.js

/**
 * Determines whether input is a Next.js not-found error.
 * https://beta.nextjs.org/docs/api-reference/notfound#notfound
 */ function isNotFoundNavigationError(subject) {
    return (0,is/* isError */.VZ)(subject) && subject.digest === "NEXT_NOT_FOUND";
}
/**
 * Determines whether input is a Next.js redirect error.
 * https://beta.nextjs.org/docs/api-reference/redirect#redirect
 */ function isRedirectNavigationError(subject) {
    return (0,is/* isError */.VZ)(subject) && typeof subject.digest === "string" && subject.digest.startsWith("NEXT_REDIRECT;") // a redirect digest looks like "NEXT_REDIRECT;[redirect path]"
    ;
}
 //# sourceMappingURL=nextNavigationErrorUtils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/utils/commonObjectTracing.js
var commonMap = new WeakMap();
/**
 * Takes a shared (garbage collectable) object between resources, e.g. a headers object shared between Next.js server components and returns a common propagation context.
 *
 * @param commonObject The shared object.
 * @param propagationContext The propagation context that should be shared between all the resources if no propagation context was registered yet.
 * @returns the shared propagation context.
 */ function commonObjectToPropagationContext(commonObject, propagationContext) {
    if (typeof commonObject === "object" && commonObject) {
        var memoPropagationContext = commonMap.get(commonObject);
        if (memoPropagationContext) {
            return memoPropagationContext;
        } else {
            commonMap.set(commonObject, propagationContext);
            return propagationContext;
        }
    } else {
        return propagationContext;
    }
}
 //# sourceMappingURL=commonObjectTracing.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapServerComponentWithSentry.js







/**
 * Wraps an `app` directory server component with Sentry error instrumentation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrapServerComponentWithSentry(appDirComponent, context) {
    (0,hubextensions/* addTracingExtensions */.T)();
    var componentRoute = context.componentRoute, componentType = context.componentType;
    // Even though users may define server components as async functions, for the client bundles
    // Next.js will turn them into synchronous functions and it will transform any `await`s into instances of the `use`
    // hook. 🤯
    return new Proxy(appDirComponent, {
        apply: function(originalFunction, thisArg, args) {
            // TODO: If we ever allow withIsolationScope to take a scope, we should pass a scope here that is shared between all of the server components, similar to what `commonObjectToPropagationContext` does.
            return (0,esm_exports/* withIsolationScope */.wi)(function(isolationScope) {
                var completeHeadersDict = context.headers ? winterCGHeadersToDict(context.headers) : {};
                isolationScope.setSDKProcessingMetadata({
                    request: {
                        headers: completeHeadersDict
                    }
                });
                var incomingPropagationContext = (0,tracing/* propagationContextFromHeaders */.pT)(// eslint-disable-next-line deprecation/deprecation
                (0,_nullishCoalesce/* _nullishCoalesce */.h)(context.sentryTraceHeader, function() {
                    return completeHeadersDict["sentry-trace"];
                }), // eslint-disable-next-line deprecation/deprecation
                (0,_nullishCoalesce/* _nullishCoalesce */.h)(context.baggageHeader, function() {
                    return completeHeadersDict["baggage"];
                }));
                var propagationContext = commonObjectToPropagationContext(context.headers, incomingPropagationContext);
                isolationScope.setPropagationContext(propagationContext);
                (0,esm_exports/* getCurrentScope */.nZ)().setPropagationContext(propagationContext);
                var _obj;
                return (0,trace/* startSpanManual */.V0)({
                    op: "function.nextjs",
                    name: "".concat(componentType, " Server Component (").concat(componentRoute, ")"),
                    attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, "component"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.function.nextjs"), _obj)
                }, function(span) {
                    return (0,handleCallbackErrors/* handleCallbackErrors */.i)(function() {
                        return originalFunction.apply(thisArg, args);
                    }, function(error) {
                        if (isNotFoundNavigationError(error)) {
                            // We don't want to report "not-found"s
                            (0,_optionalChain/* _optionalChain */.x)([
                                span,
                                "optionalAccess",
                                function(_) {
                                    return _.setStatus;
                                },
                                "call",
                                function(_2) {
                                    return _2("not_found");
                                }
                            ]);
                        } else if (isRedirectNavigationError(error)) {
                            // We don't want to report redirects
                            (0,_optionalChain/* _optionalChain */.x)([
                                span,
                                "optionalAccess",
                                function(_3) {
                                    return _3.setStatus;
                                },
                                "call",
                                function(_4) {
                                    return _4("ok");
                                }
                            ]);
                        } else {
                            (0,_optionalChain/* _optionalChain */.x)([
                                span,
                                "optionalAccess",
                                function(_5) {
                                    return _5.setStatus;
                                },
                                "call",
                                function(_6) {
                                    return _6("internal_error");
                                }
                            ]);
                            (0,esm_exports/* captureException */.Tb)(error, {
                                mechanism: {
                                    handled: false
                                }
                            });
                        }
                    }, function() {
                        (0,_optionalChain/* _optionalChain */.x)([
                            span,
                            "optionalAccess",
                            function(_7) {
                                return _7.end;
                            },
                            "call",
                            function(_8) {
                                return _8();
                            }
                        ]);
                        // flushQueue should not throw
                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                        (0,responseEnd/* flushQueue */.DO)();
                    });
                });
            });
        }
    });
}
 //# sourceMappingURL=wrapServerComponentWithSentry.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/tracing/spanstatus.js
var spanstatus = __webpack_require__(86912);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapRouteHandlerWithSentry.js
/* provided dependency */ var wrapRouteHandlerWithSentry_process = __webpack_require__(34155);









/**
 * Wraps a Next.js route handler with performance and error instrumentation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrapRouteHandlerWithSentry(routeHandler, context) {
    (0,hubextensions/* addTracingExtensions */.T)();
    // eslint-disable-next-line deprecation/deprecation
    var method = context.method, parameterizedRoute = context.parameterizedRoute, baggageHeader = context.baggageHeader, sentryTraceHeader = context.sentryTraceHeader, headers = context.headers;
    return new Proxy(routeHandler, {
        apply: function(originalFunction, thisArg, args) {
            return (0,esm_exports/* withIsolationScope */.wi)(function() {
                var _ref = (0,_async_to_generator/* default */.Z)(function(isolationScope) {
                    return (0,tslib_es6.__generator)(this, function(_state) {
                        isolationScope.setSDKProcessingMetadata({
                            request: {
                                headers: headers ? winterCGHeadersToDict(headers) : undefined
                            }
                        });
                        return [
                            2,
                            (0,trace/* continueTrace */.yn)({
                                sentryTrace: (0,_nullishCoalesce/* _nullishCoalesce */.h)((0,_nullishCoalesce/* _nullishCoalesce */.h)(sentryTraceHeader, function() {
                                    return (0,_optionalChain/* _optionalChain */.x)([
                                        headers,
                                        "optionalAccess",
                                        function(_) {
                                            return _.get;
                                        },
                                        "call",
                                        function(_2) {
                                            return _2("sentry-trace");
                                        }
                                    ]);
                                }), function() {
                                    return undefined;
                                }),
                                baggage: (0,_nullishCoalesce/* _nullishCoalesce */.h)(baggageHeader, function() {
                                    return (0,_optionalChain/* _optionalChain */.x)([
                                        headers,
                                        "optionalAccess",
                                        function(_3) {
                                            return _3.get;
                                        },
                                        "call",
                                        function(_4) {
                                            return _4("baggage");
                                        }
                                    ]);
                                })
                            }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                                var _obj;
                                return (0,tslib_es6.__generator)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                ,
                                                2,
                                                5
                                            ]);
                                            return [
                                                4,
                                                (0,trace/* startSpan */.GK)({
                                                    op: "http.server",
                                                    name: "".concat(method, " ").concat(parameterizedRoute),
                                                    attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, "route"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.function.nextjs"), _obj)
                                                }, function() {
                                                    var _ref = (0,_async_to_generator/* default */.Z)(function(span) {
                                                        var response;
                                                        return (0,tslib_es6.__generator)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        (0,handleCallbackErrors/* handleCallbackErrors */.i)(function() {
                                                                            return originalFunction.apply(thisArg, args);
                                                                        }, function(error) {
                                                                            // Next.js throws errors when calling `redirect()`. We don't wanna report these.
                                                                            if (!isRedirectNavigationError(error)) {
                                                                                (0,esm_exports/* captureException */.Tb)(error, {
                                                                                    mechanism: {
                                                                                        handled: false
                                                                                    }
                                                                                });
                                                                            }
                                                                        })
                                                                    ];
                                                                case 1:
                                                                    response = _state.sent();
                                                                    try {
                                                                        span && (0,spanstatus/* setHttpStatus */.Q0)(span, response.status);
                                                                    } catch (e) {
                                                                    // best effort - response may be undefined?
                                                                    }
                                                                    return [
                                                                        2,
                                                                        response
                                                                    ];
                                                            }
                                                        });
                                                    });
                                                    return function(span) {
                                                        return _ref.apply(this, arguments);
                                                    };
                                                }())
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                        case 2:
                                            if (!(!platformSupportsStreaming() || wrapRouteHandlerWithSentry_process.env.NEXT_RUNTIME === "edge")) return [
                                                3,
                                                4
                                            ];
                                            // 1. Edge transport requires manual flushing
                                            // 2. Lambdas require manual flushing to prevent execution freeze before the event is sent
                                            return [
                                                4,
                                                (0,responseEnd/* flushQueue */.DO)()
                                            ];
                                        case 3:
                                            _state.sent();
                                            _state.label = 4;
                                        case 4:
                                            return [
                                                7
                                            ];
                                        case 5:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            }))
                        ];
                    });
                });
                return function(isolationScope) {
                    return _ref.apply(this, arguments);
                };
            }());
        }
    });
}
 //# sourceMappingURL=wrapRouteHandlerWithSentry.js.map

// EXTERNAL MODULE: ./node_modules/@sentry/core/esm/hub.js
var hub = __webpack_require__(19217);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapApiHandlerWithSentryVercelCrons.js



/**
 * Wraps a function with Sentry crons instrumentation by automaticaly sending check-ins for the given Vercel crons config.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrapApiHandlerWithSentryVercelCrons(handler, vercelCronsConfig) {
    return new Proxy(handler, {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        apply: function(originalFunction, thisArg, args) {
            return (0,hub/* runWithAsyncContext */.Ok)(function() {
                if (!args || !args[0]) {
                    return originalFunction.apply(thisArg, args);
                }
                (0,hubextensions/* addTracingExtensions */.T)();
                var _args = (0,src_sliced_to_array/* default */.Z)(args, 1), req = _args[0];
                var maybePromiseResult;
                var cronsKey = "nextUrl" in req ? req.nextUrl.pathname : req.url;
                var userAgentHeader = "nextUrl" in req ? req.headers.get("user-agent") : req.headers["user-agent"];
                if (!vercelCronsConfig || // do nothing if vercel crons config is missing
                !(0,_optionalChain/* _optionalChain */.x)([
                    userAgentHeader,
                    "optionalAccess",
                    function(_) {
                        return _.includes;
                    },
                    "call",
                    function(_2) {
                        return _2("vercel-cron");
                    }
                ]) // do nothing if endpoint is not called from vercel crons
                ) {
                    return originalFunction.apply(thisArg, args);
                }
                var vercelCron = vercelCronsConfig.find(function(vercelCron) {
                    return vercelCron.path === cronsKey;
                });
                if (!vercelCron || !vercelCron.path || !vercelCron.schedule) {
                    return originalFunction.apply(thisArg, args);
                }
                var monitorSlug = vercelCron.path;
                var checkInId = (0,esm_exports/* captureCheckIn */.c)({
                    monitorSlug: monitorSlug,
                    status: "in_progress"
                }, {
                    maxRuntime: 60 * 12,
                    schedule: {
                        type: "crontab",
                        value: vercelCron.schedule
                    }
                });
                var startTime = Date.now() / 1000;
                var handleErrorCase = function() {
                    (0,esm_exports/* captureCheckIn */.c)({
                        checkInId: checkInId,
                        monitorSlug: monitorSlug,
                        status: "error",
                        duration: Date.now() / 1000 - startTime
                    });
                };
                try {
                    maybePromiseResult = originalFunction.apply(thisArg, args);
                } catch (e) {
                    handleErrorCase();
                    throw e;
                }
                if (typeof maybePromiseResult === "object" && maybePromiseResult !== null && "then" in maybePromiseResult) {
                    Promise.resolve(maybePromiseResult).then(function() {
                        (0,esm_exports/* captureCheckIn */.c)({
                            checkInId: checkInId,
                            monitorSlug: monitorSlug,
                            status: "ok",
                            duration: Date.now() / 1000 - startTime
                        });
                    }, function() {
                        handleErrorCase();
                    });
                    // It is very important that we return the original promise here, because Next.js attaches various properties
                    // to that promise and will throw if they are not on the returned value.
                    return maybePromiseResult;
                } else {
                    (0,esm_exports/* captureCheckIn */.c)({
                        checkInId: checkInId,
                        monitorSlug: monitorSlug,
                        status: "ok",
                        duration: Date.now() / 1000 - startTime
                    });
                    return maybePromiseResult;
                }
            });
        }
    });
}
 //# sourceMappingURL=wrapApiHandlerWithSentryVercelCrons.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/utils/edgeWrapperUtils.js







/**
 * Wraps a function on the edge runtime with error and performance monitoring.
 */ function withEdgeWrapping(handler, options) {
    return /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
        var _len, args, _key, _this, req, sentryTrace, baggage;
        var _arguments = arguments;
        return (0,tslib_es6.__generator)(this, function(_state) {
            for(_len = _arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = _arguments[_key];
            }
            _this = this;
            (0,hubextensions/* addTracingExtensions */.T)();
            req = args[0];
            if ((0,_instanceof/* default */.Z)(req, Request)) {
                sentryTrace = req.headers.get("sentry-trace") || "";
                baggage = req.headers.get("baggage");
            }
            return [
                2,
                (0,trace/* continueTrace */.yn)({
                    sentryTrace: sentryTrace,
                    baggage: baggage
                }, function() {
                    var _this1 = _this;
                    var _obj;
                    return (0,trace/* startSpan */.GK)({
                        name: options.spanDescription,
                        op: options.spanOp,
                        attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, "route"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.function.nextjs.withEdgeWrapping"), _obj),
                        metadata: {
                            request: (0,_instanceof/* default */.Z)(req, Request) ? winterCGRequestToRequestData(req) : undefined
                        }
                    }, function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(span) {
                            var handlerResult;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        return [
                                            4,
                                            (0,handleCallbackErrors/* handleCallbackErrors */.i)(function() {
                                                return handler.apply(_this1, args);
                                            }, function(error) {
                                                (0,esm_exports/* captureException */.Tb)(error, {
                                                    mechanism: {
                                                        type: "instrument",
                                                        handled: false,
                                                        data: {
                                                            function: options.mechanismFunctionName
                                                        }
                                                    }
                                                });
                                            })
                                        ];
                                    case 1:
                                        handlerResult = _state.sent();
                                        if (span) {
                                            if ((0,_instanceof/* default */.Z)(handlerResult, Response)) {
                                                (0,spanstatus/* setHttpStatus */.Q0)(span, handlerResult.status);
                                            } else {
                                                span.setStatus("ok");
                                            }
                                        }
                                        return [
                                            2,
                                            handlerResult
                                        ];
                                }
                            });
                        });
                        return function(span) {
                            return _ref.apply(this, arguments);
                        };
                    }()).finally(function() {
                        return (0,responseEnd/* flushQueue */.DO)();
                    });
                })
            ];
        });
    });
}
 //# sourceMappingURL=edgeWrapperUtils.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapMiddlewareWithSentry.js

/**
 * Wraps Next.js middleware with Sentry error and performance instrumentation.
 *
 * @param middleware The middleware handler.
 * @returns a wrapped middleware handler.
 */ function wrapMiddlewareWithSentry(middleware) {
    return new Proxy(middleware, {
        apply: function(wrappingTarget, thisArg, args) {
            return withEdgeWrapping(wrappingTarget, {
                spanDescription: "middleware",
                spanOp: "middleware.nextjs",
                mechanismFunctionName: "withSentryMiddleware"
            }).apply(thisArg, args);
        }
    });
}
 //# sourceMappingURL=wrapMiddlewareWithSentry.js.map

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get.mjs + 1 modules
var _get = __webpack_require__(45785);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_get_prototype_of.mjs
var _get_prototype_of = __webpack_require__(82662);
;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapPageComponentWithSentry.js










function isReactClassComponent(target) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return typeof target === "function" && (0,_optionalChain/* _optionalChain */.x)([
        target,
        "optionalAccess",
        function(_) {
            return _.prototype;
        },
        "optionalAccess",
        function(_2) {
            return _2.isReactComponent;
        }
    ]);
}
/**
 * Wraps a page component with Sentry error instrumentation.
 */ function wrapPageComponentWithSentry(pageComponent) {
    (0,hubextensions/* addTracingExtensions */.T)();
    if (isReactClassComponent(pageComponent)) {
        return /*#__PURE__*/ function(pageComponent) {
            "use strict";
            (0,_inherits/* default */.Z)(SentryWrappedPageComponent, pageComponent);
            var _super = (0,_create_super/* default */.Z)(SentryWrappedPageComponent);
            function SentryWrappedPageComponent() {
                (0,_class_call_check/* default */.Z)(this, SentryWrappedPageComponent);
                return _super.apply(this, arguments);
            }
            (0,_create_class/* default */.Z)(SentryWrappedPageComponent, [
                {
                    key: "render",
                    value: function render() {
                        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                            args[_key] = arguments[_key];
                        }
                        var _this = this;
                        return (0,hub/* runWithAsyncContext */.Ok)(function() {
                            var scope = (0,esm_exports/* getCurrentScope */.nZ)();
                            // We extract the sentry trace data that is put in the component props by datafetcher wrappers
                            var sentryTraceData = typeof _this.props === "object" && _this.props !== null && "_sentryTraceData" in _this.props && typeof _this.props._sentryTraceData === "string" ? _this.props._sentryTraceData : undefined;
                            if (sentryTraceData) {
                                var traceparentData = (0,tracing/* extractTraceparentData */.qG)(sentryTraceData);
                                scope.setContext("trace", {
                                    span_id: (0,_optionalChain/* _optionalChain */.x)([
                                        traceparentData,
                                        "optionalAccess",
                                        function(_3) {
                                            return _3.parentSpanId;
                                        }
                                    ]),
                                    trace_id: (0,_optionalChain/* _optionalChain */.x)([
                                        traceparentData,
                                        "optionalAccess",
                                        function(_4) {
                                            return _4.traceId;
                                        }
                                    ])
                                });
                            }
                            try {
                                var _instance;
                                return (_instance = (0,_get/* default */.Z)((0,_get_prototype_of/* default */.Z)(SentryWrappedPageComponent.prototype), "render", _this)).call.apply(_instance, [
                                    _this
                                ].concat((0,_to_consumable_array/* default */.Z)(args)));
                            } catch (e) {
                                (0,esm_exports/* captureException */.Tb)(e, {
                                    mechanism: {
                                        handled: false
                                    }
                                });
                                throw e;
                            }
                        });
                    }
                }
            ]);
            return SentryWrappedPageComponent;
        }(pageComponent);
    } else if (typeof pageComponent === "function") {
        return new Proxy(pageComponent, {
            apply: function apply(target, thisArg, argArray) {
                return (0,hub/* runWithAsyncContext */.Ok)(function() {
                    var scope = (0,esm_exports/* getCurrentScope */.nZ)();
                    // We extract the sentry trace data that is put in the component props by datafetcher wrappers
                    var sentryTraceData = (0,_optionalChain/* _optionalChain */.x)([
                        argArray,
                        "optionalAccess",
                        function(_5) {
                            return _5[0];
                        },
                        "optionalAccess",
                        function(_6) {
                            return _6._sentryTraceData;
                        }
                    ]);
                    if (sentryTraceData) {
                        var traceparentData = (0,tracing/* extractTraceparentData */.qG)(sentryTraceData);
                        scope.setContext("trace", {
                            span_id: (0,_optionalChain/* _optionalChain */.x)([
                                traceparentData,
                                "optionalAccess",
                                function(_7) {
                                    return _7.parentSpanId;
                                }
                            ]),
                            trace_id: (0,_optionalChain/* _optionalChain */.x)([
                                traceparentData,
                                "optionalAccess",
                                function(_8) {
                                    return _8.traceId;
                                }
                            ])
                        });
                    }
                    try {
                        return target.apply(thisArg, argArray);
                    } catch (e) {
                        (0,esm_exports/* captureException */.Tb)(e, {
                            mechanism: {
                                handled: false
                            }
                        });
                        throw e;
                    }
                });
            }
        });
    } else {
        return pageComponent;
    }
}
 //# sourceMappingURL=wrapPageComponentWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/wrapGenerationFunctionWithSentry.js






/**
 * Wraps a generation function (e.g. generateMetadata) with Sentry error and performance instrumentation.
 */ // eslint-disable-next-line @typescript-eslint/no-explicit-any
function wrapGenerationFunctionWithSentry(generationFunction, context) {
    (0,hubextensions/* addTracingExtensions */.T)();
    var requestAsyncStorage = context.requestAsyncStorage, componentRoute = context.componentRoute, componentType = context.componentType, generationFunctionIdentifier = context.generationFunctionIdentifier;
    return new Proxy(generationFunction, {
        apply: function(originalFunction, thisArg, args) {
            var headers = undefined;
            // We try-catch here just in case anything goes wrong with the async storage here goes wrong since it is Next.js internal API
            try {
                headers = (0,_optionalChain/* _optionalChain */.x)([
                    requestAsyncStorage,
                    "optionalAccess",
                    function(_) {
                        return _.getStore;
                    },
                    "call",
                    function(_2) {
                        return _2();
                    },
                    "optionalAccess",
                    function(_3) {
                        return _3.headers;
                    }
                ]);
            } catch (e) {
            /** empty */ }
            var data = undefined;
            if ((0,_optionalChain/* _optionalChain */.x)([
                esm_exports/* getClient */.s3,
                "call",
                function(_4) {
                    return _4();
                },
                "optionalAccess",
                function(_5) {
                    return _5.getOptions;
                },
                "call",
                function(_6) {
                    return _6();
                },
                "access",
                function(_7) {
                    return _7.sendDefaultPii;
                }
            ])) {
                var props = args[0];
                var params = props && typeof props === "object" && "params" in props ? props.params : undefined;
                var searchParams = props && typeof props === "object" && "searchParams" in props ? props.searchParams : undefined;
                data = {
                    params: params,
                    searchParams: searchParams
                };
            }
            return (0,esm_exports/* withIsolationScope */.wi)(function(isolationScope) {
                isolationScope.setSDKProcessingMetadata({
                    request: {
                        headers: headers ? winterCGHeadersToDict(headers) : undefined
                    }
                });
                isolationScope.setExtra("route_data", data);
                var incomingPropagationContext = (0,tracing/* propagationContextFromHeaders */.pT)((0,_nullishCoalesce/* _nullishCoalesce */.h)((0,_optionalChain/* _optionalChain */.x)([
                    headers,
                    "optionalAccess",
                    function(_8) {
                        return _8.get;
                    },
                    "call",
                    function(_9) {
                        return _9("sentry-trace");
                    }
                ]), function() {
                    return undefined;
                }), (0,_optionalChain/* _optionalChain */.x)([
                    headers,
                    "optionalAccess",
                    function(_10) {
                        return _10.get;
                    },
                    "call",
                    function(_11) {
                        return _11("baggage");
                    }
                ]));
                var propagationContext = commonObjectToPropagationContext(headers, incomingPropagationContext);
                isolationScope.setPropagationContext(propagationContext);
                (0,esm_exports/* getCurrentScope */.nZ)().setPropagationContext(propagationContext);
                var _obj;
                return (0,trace/* startSpanManual */.V0)({
                    op: "function.nextjs",
                    name: "".concat(componentType, ".").concat(generationFunctionIdentifier, " (").concat(componentRoute, ")"),
                    data: data,
                    attributes: (_obj = {}, (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_SOURCE */.Zj, "route"), (0,_define_property/* default */.Z)(_obj, semanticAttributes/* SEMANTIC_ATTRIBUTE_SENTRY_ORIGIN */.S3, "auto.function.nextjs"), _obj)
                }, function(span) {
                    return (0,handleCallbackErrors/* handleCallbackErrors */.i)(function() {
                        return originalFunction.apply(thisArg, args);
                    }, function(err) {
                        if (isNotFoundNavigationError(err)) {
                            // We don't want to report "not-found"s
                            (0,_optionalChain/* _optionalChain */.x)([
                                span,
                                "optionalAccess",
                                function(_12) {
                                    return _12.setStatus;
                                },
                                "call",
                                function(_13) {
                                    return _13("not_found");
                                }
                            ]);
                        } else if (isRedirectNavigationError(err)) {
                            // We don't want to report redirects
                            (0,_optionalChain/* _optionalChain */.x)([
                                span,
                                "optionalAccess",
                                function(_14) {
                                    return _14.setStatus;
                                },
                                "call",
                                function(_15) {
                                    return _15("ok");
                                }
                            ]);
                        } else {
                            (0,_optionalChain/* _optionalChain */.x)([
                                span,
                                "optionalAccess",
                                function(_16) {
                                    return _16.setStatus;
                                },
                                "call",
                                function(_17) {
                                    return _17("internal_error");
                                }
                            ]);
                            (0,esm_exports/* captureException */.Tb)(err, {
                                mechanism: {
                                    handled: false
                                }
                            });
                        }
                    }, function() {
                        (0,_optionalChain/* _optionalChain */.x)([
                            span,
                            "optionalAccess",
                            function(_18) {
                                return _18.end;
                            },
                            "call",
                            function(_19) {
                                return _19();
                            }
                        ]);
                    });
                });
            });
        }
    });
}
 //# sourceMappingURL=wrapGenerationFunctionWithSentry.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/common/withServerActionInstrumentation.js
/* provided dependency */ var withServerActionInstrumentation_process = __webpack_require__(34155);










/**
 * Wraps a Next.js Server Action implementation with Sentry Error and Performance instrumentation.
 */ function withServerActionInstrumentation() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    if (typeof args[1] === "function") {
        var _args = (0,src_sliced_to_array/* default */.Z)(args, 2), serverActionName = _args[0], callback = _args[1];
        return withServerActionInstrumentationImplementation(serverActionName, {}, callback);
    } else {
        var _args1 = (0,src_sliced_to_array/* default */.Z)(args, 3), serverActionName1 = _args1[0], options = _args1[1], callback1 = _args1[2];
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        return withServerActionInstrumentationImplementation(serverActionName1, options, callback1);
    }
}
function withServerActionInstrumentationImplementation(serverActionName, options, callback) {
    return _withServerActionInstrumentationImplementation.apply(this, arguments);
}
function _withServerActionInstrumentationImplementation() {
    _withServerActionInstrumentationImplementation = // eslint-disable-next-line @typescript-eslint/no-explicit-any
    (0,_async_to_generator/* default */.Z)(function(serverActionName, options, callback) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            (0,hubextensions/* addTracingExtensions */.T)();
            return [
                2,
                (0,esm_exports/* withIsolationScope */.wi)(function(isolationScope) {
                    var sendDefaultPii = (0,_optionalChain/* _optionalChain */.x)([
                        esm_exports/* getClient */.s3,
                        "call",
                        function(_) {
                            return _();
                        },
                        "optionalAccess",
                        function(_2) {
                            return _2.getOptions;
                        },
                        "call",
                        function(_3) {
                            return _3();
                        },
                        "access",
                        function(_4) {
                            return _4.sendDefaultPii;
                        }
                    ]);
                    var sentryTraceHeader;
                    var baggageHeader;
                    var fullHeadersObject = {};
                    try {
                        sentryTraceHeader = (0,_nullishCoalesce/* _nullishCoalesce */.h)((0,_optionalChain/* _optionalChain */.x)([
                            options,
                            "access",
                            function(_5) {
                                return _5.headers;
                            },
                            "optionalAccess",
                            function(_6) {
                                return _6.get;
                            },
                            "call",
                            function(_7) {
                                return _7("sentry-trace");
                            }
                        ]), function() {
                            return undefined;
                        });
                        baggageHeader = (0,_optionalChain/* _optionalChain */.x)([
                            options,
                            "access",
                            function(_8) {
                                return _8.headers;
                            },
                            "optionalAccess",
                            function(_9) {
                                return _9.get;
                            },
                            "call",
                            function(_10) {
                                return _10("baggage");
                            }
                        ]);
                        (0,_optionalChain/* _optionalChain */.x)([
                            options,
                            "access",
                            function(_11) {
                                return _11.headers;
                            },
                            "optionalAccess",
                            function(_12) {
                                return _12.forEach;
                            },
                            "call",
                            function(_13) {
                                return _13(function(value, key) {
                                    fullHeadersObject[key] = value;
                                });
                            }
                        ]);
                    } catch (e) {
                        debug_build/* DEBUG_BUILD */.X && logger/* logger.warn */.kg.warn("Sentry wasn't able to extract the tracing headers for a server action. Will not trace this request.");
                    }
                    isolationScope.setSDKProcessingMetadata({
                        request: {
                            headers: fullHeadersObject
                        }
                    });
                    return (0,trace/* continueTrace */.yn)({
                        sentryTrace: sentryTraceHeader,
                        baggage: baggageHeader
                    }, /*#__PURE__*/ (0,_async_to_generator/* default */.Z)(function() {
                        return (0,tslib_es6.__generator)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    _state.trys.push([
                                        0,
                                        ,
                                        2,
                                        5
                                    ]);
                                    return [
                                        4,
                                        (0,trace/* startSpan */.GK)({
                                            op: "function.server_action",
                                            name: "serverAction/".concat(serverActionName),
                                            metadata: {
                                                source: "route"
                                            }
                                        }, function() {
                                            var _ref = (0,_async_to_generator/* default */.Z)(function(span) {
                                                var result;
                                                return (0,tslib_es6.__generator)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                (0,handleCallbackErrors/* handleCallbackErrors */.i)(callback, function(error) {
                                                                    if (isNotFoundNavigationError(error)) {
                                                                        // We don't want to report "not-found"s
                                                                        (0,_optionalChain/* _optionalChain */.x)([
                                                                            span,
                                                                            "optionalAccess",
                                                                            function(_14) {
                                                                                return _14.setStatus;
                                                                            },
                                                                            "call",
                                                                            function(_15) {
                                                                                return _15("not_found");
                                                                            }
                                                                        ]);
                                                                    } else if (isRedirectNavigationError(error)) {
                                                                    // Don't do anything for redirects
                                                                    } else {
                                                                        (0,_optionalChain/* _optionalChain */.x)([
                                                                            span,
                                                                            "optionalAccess",
                                                                            function(_16) {
                                                                                return _16.setStatus;
                                                                            },
                                                                            "call",
                                                                            function(_17) {
                                                                                return _17("internal_error");
                                                                            }
                                                                        ]);
                                                                        (0,esm_exports/* captureException */.Tb)(error, {
                                                                            mechanism: {
                                                                                handled: false
                                                                            }
                                                                        });
                                                                    }
                                                                })
                                                            ];
                                                        case 1:
                                                            result = _state.sent();
                                                            if (options.recordResponse !== undefined ? options.recordResponse : sendDefaultPii) {
                                                                (0,hub/* getIsolationScope */.aF)().setExtra("server_action_result", result);
                                                            }
                                                            if (options.formData) {
                                                                options.formData.forEach(function(value, key) {
                                                                    (0,hub/* getIsolationScope */.aF)().setExtra("server_action_form_data.".concat(key), typeof value === "string" ? value : "[non-string value]");
                                                                });
                                                            }
                                                            return [
                                                                2,
                                                                result
                                                            ];
                                                    }
                                                });
                                            });
                                            return function(span) {
                                                return _ref.apply(this, arguments);
                                            };
                                        }())
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent()
                                    ];
                                case 2:
                                    if (!!platformSupportsStreaming()) return [
                                        3,
                                        4
                                    ];
                                    // Lambdas require manual flushing to prevent execution freeze before the event is sent
                                    return [
                                        4,
                                        (0,responseEnd/* flushQueue */.DO)()
                                    ];
                                case 3:
                                    _state.sent();
                                    _state.label = 4;
                                case 4:
                                    if (withServerActionInstrumentation_process.env.NEXT_RUNTIME === "edge") {
                                        // flushQueue should not throw
                                        // eslint-disable-next-line @typescript-eslint/no-floating-promises
                                        (0,responseEnd/* flushQueue */.DO)();
                                    }
                                    return [
                                        7
                                    ];
                                case 5:
                                    return [
                                        2
                                    ];
                            }
                        });
                    }));
                })
            ];
        });
    });
    return _withServerActionInstrumentationImplementation.apply(this, arguments);
}
 //# sourceMappingURL=withServerActionInstrumentation.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/client/index.js





























/** @deprecated Import the integration function directly, e.g. `inboundFiltersIntegration()` instead of `new Integrations.InboundFilter(). */ var Integrations = (0,src_object_spread_props/* default */.Z)((0,src_object_spread/* default */.Z)({}, esm.Integrations), {
    BrowserTracing: BrowserTracing
});
// Treeshakable guard to remove all code related to tracing
/** Inits the Sentry NextJS SDK on the browser with the React SDK. */ function client_init(options) {
    var opts = (0,src_object_spread/* default */.Z)({
        environment: getVercelEnv(true) || "production",
        defaultIntegrations: getDefaultIntegrations(options)
    }, options);
    fixBrowserTracingIntegration(opts);
    applyTunnelRouteOption(opts);
    (0,sdkMetadata/* applySdkMetadata */.V)(opts, "nextjs", [
        "nextjs",
        "react"
    ]);
    init(opts);
    var scope = (0,esm_exports/* getCurrentScope */.nZ)();
    scope.setTag("runtime", "browser");
    var filterTransactions = function(event) {
        return event.type === "transaction" && event.transaction === "/404" ? null : event;
    };
    filterTransactions.id = "NextClient404Filter";
    scope.addEventProcessor(filterTransactions);
    if (false) {}
}
// TODO v8: Remove this again
// We need to handle BrowserTracing passed to `integrations` that comes from `@sentry/tracing`, not `@sentry/nextjs` :(
function fixBrowserTracingIntegration(options) {
    var integrations = options.integrations;
    if (!integrations) {
        return;
    }
    if (Array.isArray(integrations)) {
        options.integrations = maybeUpdateBrowserTracingIntegration(integrations);
    } else {
        options.integrations = function(defaultIntegrations) {
            var userFinalIntegrations = integrations(defaultIntegrations);
            return maybeUpdateBrowserTracingIntegration(userFinalIntegrations);
        };
    }
}
function isNewBrowserTracingIntegration(integration) {
    // eslint-disable-next-line deprecation/deprecation
    return !!integration.afterAllSetup && !!integration.options;
}
function maybeUpdateBrowserTracingIntegration(integrations) {
    var browserTracing = integrations.find(function(integration) {
        return integration.name === "BrowserTracing";
    });
    if (!browserTracing) {
        return integrations;
    }
    // If `browserTracingIntegration()` was added, we need to force-convert it to our custom one
    if (isNewBrowserTracingIntegration(browserTracing)) {
        var options = browserTracing.options;
        // eslint-disable-next-line deprecation/deprecation
        integrations[integrations.indexOf(browserTracing)] = browserTracingIntegration_browserTracingIntegration(options);
    }
    // If BrowserTracing was added, but it is not our forked version,
    // replace it with our forked version with the same options
    // eslint-disable-next-line deprecation/deprecation
    if (!(0,_instanceof/* default */.Z)(browserTracing, BrowserTracing)) {
        // eslint-disable-next-line deprecation/deprecation
        var options1 = browserTracing.options;
        // This option is overwritten by the custom integration
        delete options1.routingInstrumentation;
        // eslint-disable-next-line deprecation/deprecation
        delete options1.tracingOrigins;
        // eslint-disable-next-line deprecation/deprecation
        integrations[integrations.indexOf(browserTracing)] = new BrowserTracing(options1);
    }
    return integrations;
}
function getDefaultIntegrations(options) {
    var customDefaultIntegrations = (0,_to_consumable_array/* default */.Z)((0,sdk/* getDefaultIntegrations */.nV)(options)).concat([
        rewriteFramesIntegration()
    ]);
    // This evaluates to true unless __SENTRY_TRACING__ is text-replaced with "false", in which case everything inside
    // will get treeshaken away
    if (false) {}
    return customDefaultIntegrations;
}
/**
 * Just a passthrough in case this is imported from the client.
 */ function withSentryConfig(exportedUserNextConfig) {
    return exportedUserNextConfig;
}
 //# sourceMappingURL=index.js.map

;// CONCATENATED MODULE: ./node_modules/@sentry/nextjs/esm/index.client.js



/***/ }),

/***/ 55532:
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", ({
    value: true
}));
var _defineProperty = (__webpack_require__(79361)/* ["default"] */ .Z);
Object.defineProperty(exports, "__esModule", ({
    value: true
}));
exports.EDGE_UNSUPPORTED_NODE_APIS = exports.RSC_MODULE_TYPES = exports.TRACE_OUTPUT_VERSION = exports.STATIC_STATUS_PAGES = exports.DEFAULT_SANS_SERIF_FONT = exports.DEFAULT_SERIF_FONT = exports.OPTIMIZED_FONT_PROVIDERS = exports.GOOGLE_FONT_PROVIDER = exports.SERVER_PROPS_ID = exports.STATIC_PROPS_ID = exports.PERMANENT_REDIRECT_STATUS = exports.TEMPORARY_REDIRECT_STATUS = exports.EDGE_RUNTIME_WEBPACK = exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL = exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS = exports.CLIENT_STATIC_FILES_RUNTIME_WEBPACK = exports.CLIENT_STATIC_FILES_RUNTIME_AMP = exports.CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH = exports.CLIENT_STATIC_FILES_RUNTIME_MAIN_APP = exports.CLIENT_STATIC_FILES_RUNTIME_MAIN = exports.MIDDLEWARE_REACT_LOADABLE_MANIFEST = exports.MIDDLEWARE_BUILD_MANIFEST = exports.FLIGHT_SERVER_CSS_MANIFEST = exports.FLIGHT_MANIFEST = exports.NEXT_CLIENT_SSR_ENTRY_SUFFIX = exports.NEXT_BUILTIN_DOCUMENT = exports.MODERN_BROWSERSLIST_TARGET = exports.STRING_LITERAL_DROP_BUNDLE = exports.CLIENT_STATIC_FILES_RUNTIME = exports.CLIENT_STATIC_FILES_PATH = exports.CLIENT_PUBLIC_FILES_PATH = exports.BLOCKED_PAGES = exports.BUILD_ID_FILE = exports.CONFIG_FILES = exports.SERVERLESS_DIRECTORY = exports.SERVER_DIRECTORY = exports.FONT_MANIFEST = exports.REACT_LOADABLE_MANIFEST = exports.DEV_MIDDLEWARE_MANIFEST = exports.MIDDLEWARE_MANIFEST = exports.DEV_CLIENT_PAGES_MANIFEST = exports.SERVER_FILES_MANIFEST = exports.IMAGES_MANIFEST = exports.ROUTES_MANIFEST = exports.PRERENDER_MANIFEST = exports.EXPORT_DETAIL = exports.EXPORT_MARKER = exports.SUBRESOURCE_INTEGRITY_MANIFEST = exports.APP_BUILD_MANIFEST = exports.BUILD_MANIFEST = exports.APP_PATH_ROUTES_MANIFEST = exports.APP_PATHS_MANIFEST = exports.PAGES_MANIFEST = exports.PHASE_TEST = exports.PHASE_DEVELOPMENT_SERVER = exports.PHASE_PRODUCTION_SERVER = exports.PHASE_PRODUCTION_BUILD = exports.PHASE_EXPORT = exports.COMPILER_INDEXES = exports.COMPILER_NAMES = void 0;
var COMPILER_NAMES = {
    client: "client",
    server: "server",
    edgeServer: "edge-server"
};
exports.COMPILER_NAMES = COMPILER_NAMES;
var _obj;
var COMPILER_INDEXES = (_obj = {}, _defineProperty(_obj, COMPILER_NAMES.client, 0), _defineProperty(_obj, COMPILER_NAMES.server, 1), _defineProperty(_obj, COMPILER_NAMES.edgeServer, 2), _obj);
exports.COMPILER_INDEXES = COMPILER_INDEXES;
var PHASE_EXPORT = "phase-export";
exports.PHASE_EXPORT = PHASE_EXPORT;
var PHASE_PRODUCTION_BUILD = "phase-production-build";
exports.PHASE_PRODUCTION_BUILD = PHASE_PRODUCTION_BUILD;
var PHASE_PRODUCTION_SERVER = "phase-production-server";
exports.PHASE_PRODUCTION_SERVER = PHASE_PRODUCTION_SERVER;
var PHASE_DEVELOPMENT_SERVER = "phase-development-server";
exports.PHASE_DEVELOPMENT_SERVER = PHASE_DEVELOPMENT_SERVER;
var PHASE_TEST = "phase-test";
exports.PHASE_TEST = PHASE_TEST;
var PAGES_MANIFEST = "pages-manifest.json";
exports.PAGES_MANIFEST = PAGES_MANIFEST;
var APP_PATHS_MANIFEST = "app-paths-manifest.json";
exports.APP_PATHS_MANIFEST = APP_PATHS_MANIFEST;
var APP_PATH_ROUTES_MANIFEST = "app-path-routes-manifest.json";
exports.APP_PATH_ROUTES_MANIFEST = APP_PATH_ROUTES_MANIFEST;
var BUILD_MANIFEST = "build-manifest.json";
exports.BUILD_MANIFEST = BUILD_MANIFEST;
var APP_BUILD_MANIFEST = "app-build-manifest.json";
exports.APP_BUILD_MANIFEST = APP_BUILD_MANIFEST;
var SUBRESOURCE_INTEGRITY_MANIFEST = "subresource-integrity-manifest";
exports.SUBRESOURCE_INTEGRITY_MANIFEST = SUBRESOURCE_INTEGRITY_MANIFEST;
var EXPORT_MARKER = "export-marker.json";
exports.EXPORT_MARKER = EXPORT_MARKER;
var EXPORT_DETAIL = "export-detail.json";
exports.EXPORT_DETAIL = EXPORT_DETAIL;
var PRERENDER_MANIFEST = "prerender-manifest.json";
exports.PRERENDER_MANIFEST = PRERENDER_MANIFEST;
var ROUTES_MANIFEST = "routes-manifest.json";
exports.ROUTES_MANIFEST = ROUTES_MANIFEST;
var IMAGES_MANIFEST = "images-manifest.json";
exports.IMAGES_MANIFEST = IMAGES_MANIFEST;
var SERVER_FILES_MANIFEST = "required-server-files.json";
exports.SERVER_FILES_MANIFEST = SERVER_FILES_MANIFEST;
var DEV_CLIENT_PAGES_MANIFEST = "_devPagesManifest.json";
exports.DEV_CLIENT_PAGES_MANIFEST = DEV_CLIENT_PAGES_MANIFEST;
var MIDDLEWARE_MANIFEST = "middleware-manifest.json";
exports.MIDDLEWARE_MANIFEST = MIDDLEWARE_MANIFEST;
var DEV_MIDDLEWARE_MANIFEST = "_devMiddlewareManifest.json";
exports.DEV_MIDDLEWARE_MANIFEST = DEV_MIDDLEWARE_MANIFEST;
var REACT_LOADABLE_MANIFEST = "react-loadable-manifest.json";
exports.REACT_LOADABLE_MANIFEST = REACT_LOADABLE_MANIFEST;
var FONT_MANIFEST = "font-manifest.json";
exports.FONT_MANIFEST = FONT_MANIFEST;
var SERVER_DIRECTORY = "server";
exports.SERVER_DIRECTORY = SERVER_DIRECTORY;
var SERVERLESS_DIRECTORY = "serverless";
exports.SERVERLESS_DIRECTORY = SERVERLESS_DIRECTORY;
var CONFIG_FILES = [
    "next.config.js",
    "next.config.mjs"
];
exports.CONFIG_FILES = CONFIG_FILES;
var BUILD_ID_FILE = "BUILD_ID";
exports.BUILD_ID_FILE = BUILD_ID_FILE;
var BLOCKED_PAGES = [
    "/_document",
    "/_app",
    "/_error"
];
exports.BLOCKED_PAGES = BLOCKED_PAGES;
var CLIENT_PUBLIC_FILES_PATH = "public";
exports.CLIENT_PUBLIC_FILES_PATH = CLIENT_PUBLIC_FILES_PATH;
var CLIENT_STATIC_FILES_PATH = "static";
exports.CLIENT_STATIC_FILES_PATH = CLIENT_STATIC_FILES_PATH;
var CLIENT_STATIC_FILES_RUNTIME = "runtime";
exports.CLIENT_STATIC_FILES_RUNTIME = CLIENT_STATIC_FILES_RUNTIME;
var STRING_LITERAL_DROP_BUNDLE = "__NEXT_DROP_CLIENT_FILE__";
exports.STRING_LITERAL_DROP_BUNDLE = STRING_LITERAL_DROP_BUNDLE;
var MODERN_BROWSERSLIST_TARGET = [
    "chrome 61",
    "edge 16",
    "firefox 60",
    "opera 48",
    "safari 11", 
];
exports.MODERN_BROWSERSLIST_TARGET = MODERN_BROWSERSLIST_TARGET;
var NEXT_BUILTIN_DOCUMENT = "__NEXT_BUILTIN_DOCUMENT__";
exports.NEXT_BUILTIN_DOCUMENT = NEXT_BUILTIN_DOCUMENT;
var NEXT_CLIENT_SSR_ENTRY_SUFFIX = ".__sc_client__";
exports.NEXT_CLIENT_SSR_ENTRY_SUFFIX = NEXT_CLIENT_SSR_ENTRY_SUFFIX;
var FLIGHT_MANIFEST = "flight-manifest";
exports.FLIGHT_MANIFEST = FLIGHT_MANIFEST;
var FLIGHT_SERVER_CSS_MANIFEST = "flight-server-css-manifest";
exports.FLIGHT_SERVER_CSS_MANIFEST = FLIGHT_SERVER_CSS_MANIFEST;
var MIDDLEWARE_BUILD_MANIFEST = "middleware-build-manifest";
exports.MIDDLEWARE_BUILD_MANIFEST = MIDDLEWARE_BUILD_MANIFEST;
var MIDDLEWARE_REACT_LOADABLE_MANIFEST = "middleware-react-loadable-manifest";
exports.MIDDLEWARE_REACT_LOADABLE_MANIFEST = MIDDLEWARE_REACT_LOADABLE_MANIFEST;
var CLIENT_STATIC_FILES_RUNTIME_MAIN = "main";
exports.CLIENT_STATIC_FILES_RUNTIME_MAIN = CLIENT_STATIC_FILES_RUNTIME_MAIN;
var CLIENT_STATIC_FILES_RUNTIME_MAIN_APP = "".concat(CLIENT_STATIC_FILES_RUNTIME_MAIN, "-app");
exports.CLIENT_STATIC_FILES_RUNTIME_MAIN_APP = CLIENT_STATIC_FILES_RUNTIME_MAIN_APP;
var CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH = "react-refresh";
exports.CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH = CLIENT_STATIC_FILES_RUNTIME_REACT_REFRESH;
var CLIENT_STATIC_FILES_RUNTIME_AMP = "amp";
exports.CLIENT_STATIC_FILES_RUNTIME_AMP = CLIENT_STATIC_FILES_RUNTIME_AMP;
var CLIENT_STATIC_FILES_RUNTIME_WEBPACK = "webpack";
exports.CLIENT_STATIC_FILES_RUNTIME_WEBPACK = CLIENT_STATIC_FILES_RUNTIME_WEBPACK;
var CLIENT_STATIC_FILES_RUNTIME_POLYFILLS = "polyfills";
exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS = CLIENT_STATIC_FILES_RUNTIME_POLYFILLS;
var CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL = Symbol(CLIENT_STATIC_FILES_RUNTIME_POLYFILLS);
exports.CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL = CLIENT_STATIC_FILES_RUNTIME_POLYFILLS_SYMBOL;
var EDGE_RUNTIME_WEBPACK = "edge-runtime-webpack";
exports.EDGE_RUNTIME_WEBPACK = EDGE_RUNTIME_WEBPACK;
var TEMPORARY_REDIRECT_STATUS = 307;
exports.TEMPORARY_REDIRECT_STATUS = TEMPORARY_REDIRECT_STATUS;
var PERMANENT_REDIRECT_STATUS = 308;
exports.PERMANENT_REDIRECT_STATUS = PERMANENT_REDIRECT_STATUS;
var STATIC_PROPS_ID = "__N_SSG";
exports.STATIC_PROPS_ID = STATIC_PROPS_ID;
var SERVER_PROPS_ID = "__N_SSP";
exports.SERVER_PROPS_ID = SERVER_PROPS_ID;
var GOOGLE_FONT_PROVIDER = "https://fonts.googleapis.com/";
exports.GOOGLE_FONT_PROVIDER = GOOGLE_FONT_PROVIDER;
var OPTIMIZED_FONT_PROVIDERS = [
    {
        url: GOOGLE_FONT_PROVIDER,
        preconnect: "https://fonts.gstatic.com"
    },
    {
        url: "https://use.typekit.net",
        preconnect: "https://use.typekit.net"
    }, 
];
exports.OPTIMIZED_FONT_PROVIDERS = OPTIMIZED_FONT_PROVIDERS;
var DEFAULT_SERIF_FONT = "Times New Roman";
exports.DEFAULT_SERIF_FONT = DEFAULT_SERIF_FONT;
var DEFAULT_SANS_SERIF_FONT = "Arial";
exports.DEFAULT_SANS_SERIF_FONT = DEFAULT_SANS_SERIF_FONT;
var STATIC_STATUS_PAGES = [
    "/500"
];
exports.STATIC_STATUS_PAGES = STATIC_STATUS_PAGES;
var TRACE_OUTPUT_VERSION = 1;
exports.TRACE_OUTPUT_VERSION = TRACE_OUTPUT_VERSION;
var RSC_MODULE_TYPES = {
    client: "client",
    server: "server"
};
exports.RSC_MODULE_TYPES = RSC_MODULE_TYPES;
var EDGE_UNSUPPORTED_NODE_APIS = [
    "clearImmediate",
    "setImmediate",
    "BroadcastChannel",
    "Buffer",
    "ByteLengthQueuingStrategy",
    "CompressionStream",
    "CountQueuingStrategy",
    "DecompressionStream",
    "DomException",
    "MessageChannel",
    "MessageEvent",
    "MessagePort",
    "ReadableByteStreamController",
    "ReadableStreamBYOBRequest",
    "ReadableStreamDefaultController",
    "TextDecoderStream",
    "TextEncoderStream",
    "TransformStreamDefaultController",
    "WritableStreamDefaultController", 
];
exports.EDGE_UNSUPPORTED_NODE_APIS = EDGE_UNSUPPORTED_NODE_APIS;
if ((typeof exports.default === "function" || typeof exports.default === "object" && exports.default !== null) && typeof exports.default.__esModule === "undefined") {
    Object.defineProperty(exports.default, "__esModule", {
        value: true
    });
    Object.assign(exports.default, exports);
    module.exports = exports.default;
} //# sourceMappingURL=constants.js.map


/***/ })

}]);